<template>
  <div v-map-event="onMapEvent">
    <div :id="myMapId" class="mymap">
      <div id="bar"></div>
      <v-dialog v-model="toggleFilter" persistent max-width="800px" style="z-index:10000;">
        <v-card>
          <v-card-title class="text-h5" style="position: sticky; color: rgba(21, 102, 124, 0.9);
                  background-color: rgb(240, 240, 240);
                  border-bottom: 2px solid #2b7588;">Map View Settings
          </v-card-title>
          <v-card-text>
            <form class="leaflet-control-layers-list">
              <v-container fluid>
                <v-row justify="start">
                  <v-col>
                    <v-checkbox class="standard-controls legendItem" v-model="mapViewModel.staffHomes"
                      @change="onMapSettingsChanged(mapViewModel.staffHomes, 'home')">
                      <template v-slot:label>
                        <img :src="legendIcons.home" style="height:45px;width:45px;" /><span
                          class="checkLabel">Interviewer Home</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.noDataTasks"
                      @change="onMapSettingsChanged(mapViewModel.noDataTasks, 'noDataTasks')">
                      <template v-slot:label>
                        <img :src="legendIcons.task" style="height:45px;width:45px;" /><span class="checkLabel">No Data
                          Task</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.erocTasks"
                      @change="onMapSettingsChanged(mapViewModel.erocTasks, 'erocTasks')">
                      <template v-slot:label>
                        <img :src="legendIcons.eroc" style="height:45px;width:45px;" /><span class="checkLabel">EROC
                          Task</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.laptopGpsPoints"
                      @change="onMapSettingsChanged(mapViewModel.laptopGpsPoints, 'laptopGpsPoints')">
                      <template v-slot:label>
                        <img :src="legendIcons.laptop" style="height:45px;width:45px;" /><span class="checkLabel">Laptop
                          GPS</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.laptopClosestGpsPoint"
                      @change="onMapSettingsChanged(mapViewModel.laptopClosestGpsPoint, 'laptopClosestGpsPoint')">
                      <template v-slot:label>
                        <img :src="legendIcons.laptopClosest" style="height:45px;width:45px;" /><span
                          class="checkLabel">Closest Laptop Point</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.clusters"
                      @change="onMapSettingsChanged(mapViewModel.clusters, 'clusters')">
                      <template v-slot:label>
                        <img :src="legendIcons.cluster" style="height:45px;width:45px;" /><span
                          class="checkLabel">Clusters</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.laptopTravelLines"
                      @change="onMapSettingsChanged(mapViewModel.laptopTravelLines, 'laptopTravelLines')">
                      <template v-slot:label>
                        <p style="width:45px; border-top: 4px dashed #06a2f9; margin-top: 15px;" />
                        <span class="checkLabel">&nbsp;&nbsp;Laptop Travel</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.events"
                      @change="onMapSettingsChanged(mapViewModel.events, 'events')">
                      <template v-slot:label>
                        <img :src="legendIcons.deviceEvent" style="height:35px;width:35px;" />
                        <img :src="legendIcons.locationServiceEvent" style="height:35px;width:35px;" />
                        <img :src="legendIcons.networkingEvent" style="height:35px;width:35px;" />
                        <img :src="legendIcons.powerEvent" style="height:35px;width:35px;" />
                        <img :src="legendIcons.fatalEvent" style="height:35px;width:35px;" />
                        <span class="checkLabel">&nbsp;&nbsp;Client Events</span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col style="text-align:center;">
                    <v-checkbox class="standard-controls" v-model="mapViewModel.validTasks"
                      @change="onMapSettingsChanged(mapViewModel.validTasks, 'validTasks')">
                      <template v-slot:label>
                        <img :src="legendIcons.valid" style="height:45px;width:45px;" /><span class="checkLabel">Valid
                          Task</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.validTasksAlternativeLocation"
                      @change="onMapSettingsChanged(mapViewModel.validTasksAlternativeLocation, 'validTasksAlternativeLocation')">
                      <template v-slot:label>
                        <img :src="legendIcons.validAlternate" style="height:45px;width:45px;" /><span class="checkLabel">Valid
                          Task Alternative Location</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.suspectTasks"
                      @change="onMapSettingsChanged(mapViewModel.suspectTasks, 'suspectTasks')">
                      <template v-slot:label>
                        <img :src="legendIcons.suspect" style="height:45px;width:45px;" /><span
                          class="checkLabel">Suspect Task</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.mrocTasks"
                      @change="onMapSettingsChanged(mapViewModel.mrocTasks, 'mrocTasks')">
                      <template v-slot:label>
                        <img :src="legendIcons.mroc" style="height:45px;width:45px;" /><span class="checkLabel">MROC
                          Task</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.phoneGpsPoints"
                      @change="onMapSettingsChanged(mapViewModel.phoneGpsPoints, 'phoneGpsPoints')">
                      <template v-slot:label>
                        <img :src="legendIcons.phone" style="height:45px;width:45px;" /><span class="checkLabel">Phone
                          GPS</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.phoneClosestGpsPoint"
                      @change="onMapSettingsChanged(mapViewModel.phoneClosestGpsPoint, 'phoneClosestGpsPoint')">
                      <template v-slot:label>
                        <img :src="legendIcons.phoneClosest" style="height:45px;width:45px;" /><span
                          class="checkLabel">Closest Phone Point</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.stopPoints"
                      @change="onMapSettingsChanged(mapViewModel.stopPoints, 'stopPoints')">
                      <template v-slot:label>
                        <img :src="legendIcons.phoneStop" style="height:45px;width:45px;" /><span
                          class="checkLabel">Phone Stop</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox class="standard-controls" v-model="mapViewModel.phoneTravelLines"
                      @change="onMapSettingsChanged(mapViewModel.phoneTravelLines, 'phoneTravelLines')">
                      <template v-slot:label>
                        <p style="width:45px;border-top: 4px dashed #e77504; margin-top: 15px;" />
                        <span class="checkLabel">&nbsp;&nbsp;Phone Travel</span>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </v-card-text>
          <v-card-actions style="position: sticky; color: rgba(21, 102, 124, 0.9);
                  background-color: rgb(240, 240, 240);
                  border-top: 2px solid #2b7588;">
            <v-btn variant="outlined" style="background: rgba(128, 128, 128, 0.1);
    border: 2px solid rgb(41, 114, 134);" @click="clearAll">
              Clear ALL
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" style="background: rgba(21, 102, 124, 0.1);
    border: 2px solid rgb(41, 114, 134);" @click="toggleFilter = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="toggleAddress" persistent max-width="450px">
        <v-card>
          <v-toolbar style="
                  position: sticky;
                  color: rgba(21, 102, 124, 0.9);
                  background-color: rgb(240, 240, 240);
                  border-bottom: 2px solid #2b7588;
                ">
            <v-toolbar-title class="text-h5">
              Find Address</v-toolbar-title>
            <template v-slot:append>
              <v-btn icon="mdi-close" text @click="closeAddress()"></v-btn>
            </template>
          </v-toolbar>
          <form class="leaflet-control-layers-list" name="locateForm" ng-model="addressModel">
            <div class="leaflet-geoaddr-content leaflet-control-layers-base">
              <table class="address-table" style="width: 95%; margin: 5px 5px 5px 5px">
                <tbody>
                  <tr>
                    <td width="40%">Street Number</td>
                    <td width="10%"></td>
                    <td width="50%" style="padding-bottom: 5px;">
                      <v-text-field v-model="addressModel.streetNum" dense variant="outlined" hide-details
                        density="compact"></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>Street Prefix</td>
                    <td width="10%"></td>
                    <td style="padding-bottom: 5px;">
                      <v-select :items="streetPrefixes" v-model="addressModel.streetPref" item-title="value"
                        item-value="value" variant="outlined" hide-details clearable density="compact"
                        style="z-index: 1000000"></v-select>
                    </td>
                  </tr>
                  <tr>
                    <td>Street Name</td>
                    <td width="10%"></td>
                    <td style="padding-bottom: 5px;">
                      <v-text-field v-model="addressModel.streetName" variant="outlined" hide-details
                        density="compact"></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>Street Type</td>
                    <td width="10%"></td>
                    <td>
                      <v-select :items="streetTypes" v-model="addressModel.streetType" item-title="value"
                        item-value="value" variant="outlined" hide-details density="compact" clearable></v-select>
                    </td>
                  </tr>
                  <tr>
                    <td>Street Suffix</td>
                    <td width="10%"></td>
                    <td>
                      <v-select :items="streetSuffixes" variant="outlined" :v-model="addressModel.streetSuf"
                        item-title="value" item-value="value" hide-details density="compact" clearable>
                      </v-select>
                    </td>
                  </tr>
                  <tr>
                    <td>Unit Type</td>
                    <td width="10%"></td>
                    <td>
                      <v-select :items="unitTypes" variant="outlined" v-model="addressModel.unitType" item-title="value"
                        item-value="value" hide-details density="compact" clearable>
                      </v-select>
                    </td>
                  </tr>
                  <tr>
                    <td>Unit Number</td>
                    <td width="10%"></td>
                    <td>
                      <v-text-field v-model="addressModel.streetUnitNo" variant="outlined" hide-details
                        density="compact"></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td width="10%"></td>
                    <td>
                      <v-text-field v-model="addressModel.city" variant="outlined" hide-details
                        density="compact"></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td width="10%"></td>
                    <td>
                      <v-select :items="states" variant="outlined" v-model="addressModel.state" item-title="value"
                        item-value="id" hide-details density="compact" clearable>
                      </v-select>
                    </td>
                  </tr>
                  <tr>
                    <td>Zip</td>
                    <td width="10%"></td>
                    <td>
                      <v-text-field v-model="addressModel.zipcode" variant="outlined" hide-details
                        density="compact"></v-text-field>
                    </td>
                  </tr>

                </tbody>
              </table>
              <v-row v-if="errLocate.hasError">
                <v-col cols="12">
                  <span class="locate-error">Error: {{ errLocate.errMessage }}</span>
                </v-col>
              </v-row>
            </div>
          </form>
          <v-card-actions
            style="color: rgba(21, 102, 124, 0.9); background-color: rgb(240, 240, 240); border-top: 2px solid #297286;">


            <v-btn style="
                    background: rgba(128, 128, 128, 0.1)
                    border: 2px solid #297286;
                  " variant="outlined" @click="clearAddress()">
              Clear
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn style="
                    background: rgba(21, 102, 124, 0.1);
                    border: 2px solid #297286;
                  " variant="outlined" @click="createAddress()">
              FIND
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
// import {ref, Vue} from "vue";
import * as L from "leaflet";
import "leaflet-polylinedecorator";

import { mapGetters } from 'vuex';

import { geoService } from "../services/geo.service";
import { mapService } from "../services/map.service";
import { staffService } from "../services/staff.service";
// import { authTokenService } from "../services/authTokenService";
import { mapMarkerService } from "@/services/map.marker.service.js";
import { mapControlService } from "@/services/map.control.service.js";

import { MAP_CONSTANTS } from "@/common/map.constants.js";
import { TASK_CONSTANTS } from "@/common/task.constants.js";
import { STORE_CONSTANTS } from '@/common/store.constants';

export default {
  name: "LeafletMap",
  props: {
    mapId: String,
    staffName: String,
    staffId: String,
    study: String,
  },
  data: function () {
    return {
      STORE_CONSTANTS,
      isFullScreen: false,
      // Used to show/hide the filter popup
      toggleFilter: false,
      // Model used to hold settings for what to display on the map
      mapViewModel: {
        staffHomes: true,
        polys: true,
        clusters: true,
        phoneGpsPoints: true,
        laptopGpsPoints: true,
        stopPoints: true,
        laptopClosestGpsPoint: true,
        phoneClosestGpsPoint: true,
        erocTasks: true,
        mrocTasks: true,
        noDataTasks: true,
        laptopTravelLines: true,
        phoneTravelLines: true,
        tasks: true,
        validTasks: true,
        validTasksAlternativeLocation: true,
        suspectTasks: true,
        satellite: false,
        events: true
      },
      // variables for finding and displaying address location on map
      addressModel: {
        streetNum: '',
        streetPref: '',
        streetName: '',
        streetType: '',
        streetSuf: '',
        unitType: '',
        streetUnitNo: '',
        city: '',
        state: '',
        zipcode: ''
      },
      errLocate: {
        hasError: false,
        errMessage: ''
      },
      // Used to hold any looked up map markers (address search)
      foundAddressMarkers: [],
      // Used to show hide the filter dialog
      toggleAddress: false,
      // marker icons
      markerIcons: MAP_CONSTANTS.MARKER_ICONS,
      // Icons used for filter popup
      legendIcons: MAP_CONSTANTS.LEGEND_ICONS,
      SuspectTasksCount: null,
      unsortedTasks: null,
      allPoints: null,
      allTasks: null,
      allMarkers: [],
      //new stuff...
      mapTrackPopup: null,
      renderer: null,
      // Markers placed on\displayed on the map
      mapLayerGroups: {
        home: null,
        erocTasks: null,
        mrocTasks: null,
        noDataTasks: null,
        radius: null,
        tasks: null,
        validTasks: null,
        validTasksAlternativeLocation: null,
        suspectTasks: null,
        other: null,
        polys: null,
        //clusters
        clusters: null,
        stopPoints: null,
        //track info
        laptopGpsPoints: null,
        phoneGpsPoints: null,
        laptopClosestGpsPoint: null,
        phoneClosestGpsPoint: null,
        laptopTravelLines: null,
        phoneTravelLines: null,
        // satellites: null,
        events: null
      },
      mapLayerTravelLineArrows: {
        laptop: [],
        phone: [],
      },
      TASK_LAYER_NAMES: ['home', 'erocTasks', 'mrocTasks', 'noDataTasks', 'tasks', 'validTasks', 'validTasksAlternativeLocation', 'suspectTasks', 'other', 'polys', 'radius'],
      CLUSTER_LAYER_NAMES: ['clusters', 'stopPoints'],
      TRACK_LAYER_NAMES: ['home', 'laptopGpsPoints', 'phoneGpsPoints', 'laptopClosestGpsPoint', 'phoneClosestGpsPoint', 'laptopTravelLines', 'phoneTravelLines', "events"],
      LAPTOP_TRACK_LAYER_NAMES: ['laptopGpsPoints', 'laptopClosestGpsPoint', 'laptopTravelLines', "events"],
      PHONE_TRACK_LAYER_NAMES: ['phoneGpsPoints', 'phoneClosestGpsPoint', 'phoneTravelLines'],
      overlayMaps: null,
      layerCtrl: null,
      tracksGroup: null,
      tasksMap: {},
      selectedPopup: null,
      areDayTracksLoaded: false,
      dayTracksControl: null,
      // Holds whether or not we have zoomed into the closest cluster/GPS point
      isZoomedIn: false,
      logMarkerInfo: true,
      showClosestClusterClicked: false
    };
  },
  created() {
    //Set me reference to this LeafletMap component instance...
    const me = this;

    // Subscribe to listen to mutations to the map store
    me.unsubscribe = me.$store.subscribe((mutation, state) => {

      //Clear all data from/on the map
      if (mutation.type === me.STORE_CONSTANTS.VALIDATION.ACTIONS.WITH_NAMESPACE.CLEAR_MAP_DATA) {
        me.onClearDataFromMapHandler();
      }

      // Add task features to the map
      if (mutation.type === me.STORE_CONSTANTS.TRACKS.MUTATIONS.WITH_NAMESPACE.SET_TASKS_FEATURES) {
        me.onAddTasksDataToMapHandler(state.tracks.taskFeatures);
      }

      // task selected for popup
      if (mutation.type === me.STORE_CONSTANTS.TRACKS.MUTATIONS.WITH_NAMESPACE.SET_SELECTED_POINT_ID) {
        me.onPointSelectedHandler(state.tracks.selectedPointId);
      }

      // add clusters data to the map
      if (mutation.type === me.STORE_CONSTANTS.TRACKS.MUTATIONS.WITH_NAMESPACE.SET_CLUSTER) {
        me.onAddClustersDataToMapHandler(state.tracks.clusters);
      }

      // add track data to the map for a particular task
      if (mutation.type === me.STORE_CONSTANTS.TRACKS.MUTATIONS.WITH_NAMESPACE.SET_TASK_TRACKS) {
        me.onAddTaskTracksDataToMapHandler(state.tracks.taskTracks);
      }

      // Set all day track info (clusters, stops, gps, etc.)
      if (mutation.type === me.STORE_CONSTANTS.TRACKS.MUTATIONS.WITH_NAMESPACE.SET_DAY_TRACKS) {
        me.onAddDayTracksDataToMapHandler(state.tracks.dayTracks, false, state.tracks.clientEvents);
      }

      // Set all day track info (stops, gps, etc.).
      if (mutation.type === me.STORE_CONSTANTS.TRACKS.MUTATIONS.WITH_NAMESPACE.SET_DAY_CLUSTERS_AND_TRACKS) {
        me.onAddDayTracksDataToMapHandler(state.tracks.dayClusterAndTracks, true, state.tracks.clientEvents);
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();

    if (this.myMap) {
      this.myMap.off('popupopen');
    }
  },
  watch: {
    isRadiusDrawOn(newVal) {
      console.log('[LeafletMap] Watching isRadiusDrawOn:', newVal);

      const iconSpan = this.radiusControlDiv?.querySelector('span.mdi');
      if (iconSpan) {
        iconSpan.className = newVal ? "mdi mdi-circle" : "mdi mdi-circle-outline";
      }

      if (newVal) {
        this.onDrawRadiusClicked(); // Show circles
      } else {
        this.mapLayerGroups['radius'].clearLayers(); // Clear circles
      }
    }
  },
  computed: {
    // Returns the list of available street prefixes to display in address
    // search popup dialog
    streetPrefixes: function () {
      return mapService.getStreetPrefixes();
    },
    // Returns the list of available street suffixes to display in address
    // search popup dialog
    streetSuffixes: function () {
      return mapService.getStreetSuffixes();
    },
    // Returns the list of available states to display in address
    // search popup dialog
    states: function () {
      return mapService.getStates();
    },
    // Returns the list of available unit types to display in address
    // search popup dialog
    unitTypes: function () {
      return mapService.getUnitTypes();
    },
    // Returns the list of available street types to display in address
    // search popup dialog
    streetTypes: function () {
      return mapService.getStreetTypes();
    },
    // Returns the whether or not an error occured during address lookup and the error message
    locationError: function () {
      return (this.errLocate && (this.errLocate.hasError && this.errLocate.hasError === true));
    },
    // Returns whether or not the map set to full screen mode
    isMapFullScreen: function () {
      return this.isFullScreen;
    },
    // Returns the id used for the map's HTML element
    myMapId: function () {
      return 'leaflet-' + this.mapId;
    },

    ...mapGetters("tracks", [
      "getTaskFeatures"
    ]),
    isRadiusDrawOn() {
      return this.$store.getters['map/isRadiusDrawOn'];
    },
  },
  /**
   * Initializes the Leaflet map control and creates all
   * of the required Leaflet map controls.
   */
  mounted() {
    //Set me reference to this LeafletMap component instance...
    const me = this;

    const layerSettings = MAP_CONSTANTS.DEFAULT_LAYERS_SETTINGS;

    me.renderer = L.canvas();
    me.mapTrackPopup = L.popup();

    const ALL_LAYER_NAMES = me.TASK_LAYER_NAMES
      .concat(me.CLUSTER_LAYER_NAMES)
      .concat(me.TRACK_LAYER_NAMES);

    ALL_LAYER_NAMES.forEach((layerName) => {
      me.mapLayerGroups[layerName] = L.layerGroup();
    });

    // Create instance of 'Normal' view map layer...
    let normal = L.tileLayer(
      layerSettings.NORMAL.URL,
      {
        attribution: layerSettings.NORMAL.ATTRIBUTION,
        maxZoom: layerSettings.NORMAL.MAX_ZOOM,
        id: layerSettings.NORMAL.ID,
        tileSize: layerSettings.NORMAL.TILE_SIZE,
        zoomOffset: layerSettings.NORMAL.ZOOM_OFFSET,
      }
    );

    // Create instance of satellite view map layer.
    let satellite = L.tileLayer(
      layerSettings.SATELLITE.URL,
      {
        id: layerSettings.SATELLITE.ID,
        maxZoom: layerSettings.SATELLITE.MAX_ZOOM,
        subdomains: layerSettings.SATELLITE.SUB_DOMAINS,
      }
    );

    // Create instance of Leaflet Map Control.
    this.myMap = L.map(this.myMapId, {
      center: MAP_CONSTANTS.MAP_CENTER,
      zoom: MAP_CONSTANTS.DEFAULT_ZOOM,
      layers: [satellite, normal],
      preferCanvas: true,
      renderer: me.renderer,
      zoomAnimation: false,
      doubleClickZoom: false
    });

    let baseMaps = {
      Satellite: satellite,
      Normal: normal,
    };

    // Append the base Maps/Layers to the Map. This also appends
    // a control to toggle between the different 'base' maps configured
    // for the map. The toggle control is in the upper right hand corner.
    // this.layerCtrl = L.control.layers(baseMaps, this.overlayMaps).addTo(this.myMap);
    this.layerCtrl = L.control.layers(baseMaps).addTo(this.myMap);

    // DD - TODO - think about moving this to a service that reads from some config or something....

    // Sets the scale bottom left
    mapControlService.addScaleControlToMap(this.myMap);

    // Add the measurement control to the map on the bottom right
    let polylineMeasure = mapControlService.addPolylineMeasurerControlToMap(this.myMap);

    // Add the find address control to the map on the top left
    let addressControl = L.control({ position: "topleft" });
    addressControl.onAdd = function (map) {
      let div = L.DomUtil.create("div");

      // clean up this part
      div.innerHTML = ``;
      div.onclick = function (evt) {
        me.showAddressPopup(evt);
      };
      //set class attribute
      div.setAttribute('class', 'map-button mdi mdi-map-marker-outline tool');
      return div;
    };
    addressControl.addTo(this.myMap); // add find address control to the map

    // Add the map markers filter control to the map on the top left
    let filterControl = L.control({ position: "topleft" });
    filterControl.onAdd = function (map) {
      let div = L.DomUtil.create("div");

      // clean up this part
      div.innerHTML = ``;
      div.onclick = function (evt) {
        me.showFilterPopup(evt);
      };
      //set class attribute
      div.setAttribute('class', 'map-button mdi mdi-filter-outline tool');

      return div;
    };
    filterControl.addTo(this.myMap); // add map markers filter control to the map

    // Add the laptop track control to the map on the top left
    let laptopControl = L.control({ position: "topleft" });
    laptopControl.onAdd = function (map) {
      let div = L.DomUtil.create("div");

      // clean up this part
      div.innerHTML = ``;
      // onclick handler
      div.onclick = function (evt) {
        me.mapViewModel.laptopTravelLines = !me.mapViewModel.laptopTravelLines;
        if (me.mapViewModel.laptopTravelLines) {
          if (evt.currentTarget.className.indexOf('disabled') !== -1) {
            evt.currentTarget.className = evt.currentTarget.className.replace(' disabled', '');
          }
        } else {
          if (evt.currentTarget.className.indexOf('disabled') == -1) {
            evt.currentTarget.className += ' disabled';
          }
        }
        me.onMapSettingsChanged(me.mapViewModel.laptopTravelLines, 'laptopTravelLines');
      };
      //set the class attribute
      div.setAttribute('class', 'map-button laptop tool');

      return div;
    };
    laptopControl.addTo(this.myMap); // add laptop track control to the map

    // Add the phone track control to the map on the top left
    let cellphoneControl = L.control({ position: "topleft" });
    cellphoneControl.onAdd = function (map) {
      let div = L.DomUtil.create("div");
      // clean up this part
      div.innerHTML = ``;

      div.onclick = function (evt) {
        me.mapViewModel.phoneTravelLines = !me.mapViewModel.phoneTravelLines;
        if (me.mapViewModel.phoneTravelLines) {
          if (evt.currentTarget.className.indexOf('disabled') !== -1) {
            evt.currentTarget.className = evt.currentTarget.className.replace(' disabled', '');
          }
        } else {
          if (evt.currentTarget.className.indexOf('disabled') == -1) {
            evt.currentTarget.className += ' disabled';
          }
        }
        me.onMapSettingsChanged(me.mapViewModel.phoneTravelLines, 'phoneTravelLines');
      };

      div.setAttribute('class', 'map-button cellphone tool');
      return div;
    };
    cellphoneControl.addTo(this.myMap); // add cellphones track control to the map

    // Add the clear map control to the map on the top left
    let resetMapControl = L.control({ position: "topleft" });
    resetMapControl.onAdd = function (map) {

      let div = L.DomUtil.create("div");
      // clean up this part
      div.innerHTML = ``;

      div.onclick = function (evt) {
        me.resetMap(evt);
      };

      div.setAttribute('class', 'map-button mdi mdi-cached tool');

      return div;
    };
    resetMapControl.addTo(this.myMap); //  add reset control to the map

    // Add the fullscreen control to the map on the top left
    let fullscreenControl = L.control({ position: "topleft" });
    fullscreenControl.onAdd = function (map) {

      let div = L.DomUtil.create("div");
      // clean up this part
      div.innerHTML = ``;

      div.onclick = function (evt) {
        me.isFullScreen = !me.isFullScreen;
        me.onFullScreenClicked(me.isFullScreen);
      };

      const iconClass = (me.isFullScreen === true) ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all';
      div.setAttribute('class', 'map-button mdi tool ' + iconClass);
      div.setAttribute('id', me.myMapId + '-full-screen');
      return div;
    };
    fullscreenControl.addTo(this.myMap); // add fullscreen control to the map

    // Add the show day tracks control to the map on the top left
    this.dayTracksControl = L.control({ position: "topleft" });
    this.dayTracksControl.onAdd = function (map) {

      let div = L.DomUtil.create("div");
      // clean up this part
      div.innerHTML = ``;

      div.onclick = function (evt) {
        me.$emit('show-day-tracks', this.taskname);
      };

      div.setAttribute('class', 'map-button mdi mdi-shoe-print tool');
      div.setAttribute('data-cy', 'map-get-day-tracks')

      return div;
    };
    // dayTracksControl.addTo(this.myMap); //  add reset control to the map

    // Add the radius control
    let radiusControl = L.control({ position: "topleft" });
    me.radiusControlDiv = null;
    radiusControl.onAdd = function (map) {
      const div = L.DomUtil.create("div");
      div.className = 'map-button mdi tool';
      div.id = me.myMapId + '-draw-radius';

      const iconSpan = L.DomUtil.create("span", "mdi mdi-circle-outline", div);

      iconSpan.className = "mdi mdi-circle-outline";

      div.onclick = () => {
        const currentState = me.$store.getters['map/isRadiusDrawOn'];
        const newState = !currentState;
        me.$store.dispatch('map/toggleRadiusDrawState', newState);
      };

      me.radiusControlDiv = div;
      return div;
    };

    radiusControl.addTo(this.myMap);

    // Add the dynamic time slice control
    let timeSliceControl = L.control({ position: "topleft" });
    me.timeSliceControlDiv = null;

    timeSliceControl.onAdd = function (map) {
        // Create a root wrapper element that Leaflet can manage
        const wrapper = L.DomUtil.create("div", "time-slice-control-wrapper");
        wrapper.style.display = "flex";
        wrapper.style.alignItems = "center";
    
        // FORCE ALIGNMENT: Strip the default Leaflet control margin shifts
        wrapper.style.marginLeft = "0";

        // Create the standard circular map button
        const mainButton = L.DomUtil.create("div", "map-button mdi tool", wrapper);
        mainButton.id = me.myMapId + '-time-slice';

        // FORCE THE BUTTON TO RETAIN ITS SHAPE AND SPACING
        mainButton.style.flexShrink = "0"; 
        mainButton.style.display = "flex";
        mainButton.style.alignItems = "center";
        mainButton.style.justifyContent = "center";

        const iconSpan = L.DomUtil.create("span", "mdi mdi-clock-outline", mainButton);

        // Create the horizontal active status pill (hidden by default)
        const activePill = L.DomUtil.create("div", "time-slice-active-pill", wrapper);
        activePill.style.display = "none";
        activePill.style.backgroundColor = "white";
        activePill.style.padding = "5px 10px";
        activePill.style.borderRadius = "4px";
        activePill.style.boxShadow = "0 1px 5px rgba(0,0,0,0.4)";
        activePill.style.fontSize = "12px";
        activePill.style.fontWeight = "bold";
        activePill.style.fontFamily = "sans-serif";
        activePill.style.alignItems = "center";
        activePill.style.gap = "8px";
        activePill.style.cursor = "default";

        // HTML setup for the active filter dashboard interface
        activePill.innerHTML = `
          <span class="mdi mdi-filter-variant" style="color: #2196F3;"></span>
          <span id="ts-pill-text">00:00 - 00:00</span>
          <button id="ts-pill-close-btn" style="background: none; border: none; font-weight: bold; color: #888; cursor: pointer; padding: 0 2px; font-size: 14px;">&times;</button>
        `;

        // Create the configuration popup content
        const popupContent = L.DomUtil.create("div", "time-slice-popup-container");
        popupContent.innerHTML = `
          <h4 style="margin: 0 0 10px 0; font-size: 14px;">Filter GPS by Hour</h4>
          <div style="display: flex; gap: 10px; margin-bottom: 5px; align-items: center;">
            <label style="font-size: 12px;">
              Start:<br />
              <input type="number" id="ts-start" min="0" max="23" value="15" style="width: 50px;" />
            </label>
            <label style="font-size: 12px;">
              End:<br />
              <input type="number" id="ts-end" min="1" max="24" value="16" style="width: 50px;" />
            </label>
          </div>
          <div id="ts-error-msg" style="color: red; font-size: 11px; margin-bottom: 10px; display: none; max-width: 130px; font-weight: bold;"></div>
          <div style="display: flex; gap: 5px;">
            <button id="ts-apply-btn" style="flex: 1; cursor: pointer; padding: 4px;">Apply</button>
            <button id="ts-reset-btn" style="flex: 1; cursor: pointer; padding: 4px; background: #eee; border: 1px solid #ccc;">Reset</button>
          </div>
        `;

        const popup = L.popup({
          offset: [0, -5],
          closeButton: true,
          autoClose: false,
          closeOnEscapeKey: true
        }).setContent(popupContent);

        // UI Transition Helpers
        const showActiveState = (start, end) => {
            mainButton.style.display = "none";
            
            // Format hours cleanly as 24h intervals (e.g., "15:00 - 16:00")
            document.getElementById('ts-pill-text').innerText = `${String(start).padStart(2, '0')}:00 - ${String(end).padStart(2, '0')}:00`;
            activePill.style.display = "flex";
        };

        const showNormalState = () => {
            activePill.style.display = "none";
            mainButton.style.display = "flex";
        };

        // Click handler for the normal state clock icon
        mainButton.onclick = (e) => {
          L.DomEvent.stopPropagation(e);

          if (popup.isOpen()) {
            map.closePopup(popup);
          } else {
            const latLng = map.containerPointToLatLng(L.point(mainButton.offsetLeft + 40, mainButton.offsetTop + 20));
            popup.setLatLng(latLng).openOn(map);

            const startInput = document.getElementById('ts-start');
            const endInput = document.getElementById('ts-end');
            const errorDiv = document.getElementById('ts-error-msg');

            const showError = (msg) => {
              errorDiv.innerText = msg;
              errorDiv.style.display = 'block';
            };

            const clearError = () => { errorDiv.style.display = 'none'; };

            startInput.oninput = () => {
              clearError();
              let val = parseInt(startInput.value, 10);
              if (val < 0) startInput.value = 0;
              if (val > 23) startInput.value = 23;
            };

            endInput.oninput = () => {
              clearError();
              let val = parseInt(endInput.value, 10);
              if (val < 1) endInput.value = 1;
              if (val > 24) endInput.value = 24;
            };

            // Apply filter logic
            document.getElementById('ts-apply-btn').onclick = () => {
              clearError();
              let startHour = parseInt(startInput.value, 10);
              let endHour = parseInt(endInput.value, 10);
              
              if (isNaN(startHour)) startHour = 0;
              if (isNaN(endHour)) endHour = 24;

              if (startHour >= endHour) {
                showError("Start must be earlier than End.");
                return;
              }

              // Apply the map adjustments
              me.filterGpsByTime(startHour, endHour);
              
              // Shift the UI state and close parameters
              showActiveState(startHour, endHour);
              map.closePopup(popup);
            };

            document.getElementById('ts-reset-btn').onclick = () => {
              clearError();
              startInput.value = 15;
              endInput.value = 16;
              me.resetTimeFilter();
              showNormalState();
              map.closePopup(popup);
            };
          }
        };

        // Click handler for the inline close (X) button on the active display pill
        activePill.querySelector('#ts-pill-close-btn').onclick = (e) => {
            L.DomEvent.stopPropagation(e);
            
            // Revert configuration settings back to baseline defaults
            if (document.getElementById('ts-start')) document.getElementById('ts-start').value = 15;
            if (document.getElementById('ts-end')) document.getElementById('ts-end').value = 16;
            
            me.resetTimeFilter();
            showNormalState();
        };

        // Keep map events from propagating through our new pill UI container
        L.DomEvent.disableClickPropagation(wrapper);
        L.DomEvent.disableScrollPropagation(wrapper);
        L.DomEvent.disableClickPropagation(popupContent);
        L.DomEvent.disableScrollPropagation(popupContent);

        me.timeSliceControlDiv = wrapper;
        return wrapper;
    };

    timeSliceControl.addTo(this.myMap); 
        
    // Playback Engine Core States (Attach to 'me' or component context)
    me.playbackTimer = null;
    me.currentPlaybackIndex = 0;
    me.playbackPointsSorted = [];
    me.playbackHighlightMarker = null;
    me.playbackPolyline = null; // Holds the creeping chronological track line

    let pathPlaybackControl = L.control({ position: "bottomleft" });
    pathPlaybackControl.onAdd = function (map) {
        const wrapper = L.DomUtil.create("div", "gps-path-playback-wrapper");
        wrapper.style.backgroundColor = "rgba(255, 255, 255, 0.35)";
        wrapper.style.padding = "8px 12px";
        wrapper.style.borderRadius = "4px";
        wrapper.style.boxShadow = "0 1px 5px rgba(0,0,0,0.4)";
        wrapper.style.display = "flex";
        wrapper.style.alignItems = "center";
        wrapper.style.gap = "10px";
        wrapper.style.fontFamily = "sans-serif";
        wrapper.style.fontSize = "12px";

        wrapper.innerHTML = `
            <b style="margin-right: 5px; color: #111;">Track Playback:</b>
            <button id="ppb-play-btn" style="cursor:pointer; padding: 4px 8px;">▶ Play</button>
            <button id="ppb-pause-btn" style="cursor:pointer; padding: 4px 8px;" disabled>⏸ Pause</button>
            <button id="ppb-stop-btn" style="cursor:pointer; padding: 4px 8px;" disabled>■ Reset</button>
            
            <select id="ppb-speed-sel" style="padding: 4px; cursor: pointer; font-size: 11px;">
                <option value="1000">Slow</option>
                <option value="650" selected>Med</option>
                <option value="300">Fast</option>
            </select>

            <span id="ppb-status" style="color: #222; font-weight: bold; min-width: 90px; margin-left: 5px;">Stopped</span>
        `;

        L.DomEvent.disableClickPropagation(wrapper);
        L.DomEvent.disableScrollPropagation(wrapper);

        setTimeout(() => {
            const playBtn = document.getElementById('ppb-play-btn');
            const pauseBtn = document.getElementById('ppb-pause-btn');
            const stopBtn = document.getElementById('ppb-stop-btn');
            const speedSel = document.getElementById('ppb-speed-sel'); // Grab dropdown
            const statusTxt = document.getElementById('ppb-status');            

            // Move the step execution out so it can be called at any interval speed
            const runAnimationStep = () => {
                try {
                    if (me.currentPlaybackIndex >= me.playbackPointsSorted.length) {
                        clearInterval(me.playbackTimer);
                        me.playbackTimer = null;
                        playBtn.disabled = false;
                        pauseBtn.disabled = true;
                        statusTxt.innerText = "Finished";
                        return;
                    }

                    const activeMarker = me.playbackPointsSorted[me.currentPlaybackIndex];
                    if (!activeMarker || typeof activeMarker.getLatLng !== 'function') {
                        me.currentPlaybackIndex++;
                        return;
                    }

                    const latLng = activeMarker.getLatLng();
                    const timeStamp = activeMarker.feature && activeMarker.feature.properties ? activeMarker.feature.properties.Time : null;

                    if (timeStamp) {
                        const timeParts = String(timeStamp).trim().split(/\s+/);
                        statusTxt.innerText = timeParts[1] ? `${timeParts[1]}` : `Point ${me.currentPlaybackIndex + 1}`;
                    }

                    if (activeMarker._icon) activeMarker._icon.style.setProperty('display', 'flex', 'important');
                    if (activeMarker._shadow) activeMarker._shadow.style.setProperty('display', 'flex', 'important');

                    if (me.playbackPolyline) {
                        me.playbackPolyline.addLatLng(latLng);
                    }

                    map.panTo(latLng, { animate: true, duration: 0.3 });

                    // Draw/Move your custom animated character cursor
                    if (me.playbackHighlightMarker) {
                        me.playbackHighlightMarker.setLatLng(latLng);
                    } else {
                        const pulseIcon = L.divIcon({
                            className: 'pacman-cursor', // Or 'knievel-cursor'
                            html: '<div class="pacman-top"></div><div class="pacman-bottom"></div>',
                            iconSize: [24, 24],
                            iconAnchor: [12, 12]
                        });
                        me.playbackHighlightMarker = L.marker(latLng, { zIndexOffset: 2000, icon: pulseIcon }).addTo(map);
                    }

                    me.currentPlaybackIndex++;

                } catch (err) {
                    console.error("Playback Engine Error", err);
                    me.currentPlaybackIndex++;
                }
            };

            // PLAY BUTTON
            playBtn.onclick = () => {
                const gpsLayerGroup = me.mapLayerGroups['laptopGpsPoints'];

                if (!gpsLayerGroup) return;

                // Initial setup on absolute fresh start
                if (me.currentPlaybackIndex === 0 && me.playbackPointsSorted.length === 0) {
                    me.playbackPointsSorted = [];
                    gpsLayerGroup.eachLayer((marker) => {
                        if (marker.feature && marker.feature.properties) {
                            me.playbackPointsSorted.push(marker);
                        }
                    });

                    if (me.playbackPointsSorted.length === 0) {
                        statusTxt.innerText = "No data!";
                        return;
                    }

                    me.playbackPointsSorted.sort((a, b) => {
                        return new Date(a.feature.properties.Time) - new Date(b.feature.properties.Time);
                    });

                    me.playbackPointsSorted.forEach(m => {
                        if (m._icon) m._icon.style.setProperty('display', 'none', 'important');
                    });

                    me.playbackPolyline = L.polyline([], { color: '#0078ff', weight: 4, opacity: 0.7 }).addTo(map);
                }

                playBtn.disabled = true;
                pauseBtn.disabled = false;
                stopBtn.disabled = false;

                // Fire the interval using the currently selected dropdown millisecond value
                const currentSpeed = parseInt(speedSel.value, 10);
                me.playbackTimer = setInterval(runAnimationStep, currentSpeed);
            };

            // MID-FLIGHT SPEED ADJUSTMENT LISTENERS
            speedSel.onchange = () => {
                // If the simulation is actively playing, rebuild the timer scale seamlessly
                if (me.playbackTimer) {
                    clearInterval(me.playbackTimer);
                    const newSpeed = parseInt(speedSel.value, 10);
                    me.playbackTimer = setInterval(runAnimationStep, newSpeed);
                }
            };

            // PAUSE BUTTON
            pauseBtn.onclick = () => {
                clearInterval(me.playbackTimer);
                me.playbackTimer = null;
                playBtn.disabled = false;
                pauseBtn.disabled = true;
                statusTxt.innerText = "Paused";
            };

            // RESET BUTTON
            stopBtn.onclick = () => {
                clearInterval(me.playbackTimer);
                me.playbackTimer = null;
                playBtn.disabled = false;
                pauseBtn.disabled = true;
                stopBtn.disabled = true;
                statusTxt.innerText = "Stopped";

                if (me.playbackPolyline) { map.removeLayer(me.playbackPolyline); me.playbackPolyline = null; }
                if (me.playbackHighlightMarker) { map.removeLayer(me.playbackHighlightMarker); me.playbackHighlightMarker = null; }
                
                if (me.playbackPointsSorted) {
                    me.playbackPointsSorted.forEach(m => { if (m._icon) m._icon.style.display = 'flex'; });
                }

                me.currentPlaybackIndex = 0;
                me.playbackPointsSorted = [];
            };

        }, 50);

        return wrapper;
      }

    pathPlaybackControl.addTo(this.myMap);    

    this.myMap.on('popupopen', (evt) => {
      me.selectedPopup = evt.popup;
    });

    // Set the map viewport to fit the default bounds
    this.myMap.fitBounds(
      MAP_CONSTANTS.DEFAULT_BOUNDS,
      {
        animate: false,
        padding: [25, 25]
      }
    );
    // Trigger watcher manually once on load
    const initialState = this.$store.getters['map/isRadiusDrawOn'];
    this.$watch(
      () => this.$store.getters['map/isRadiusDrawOn'],
      (newVal) => {
        console.log('[LeafletMap] Watching isRadiusDrawOn:', newVal);

        const iconSpan = this.radiusControlDiv?.querySelector('span.mdi');
        if (iconSpan) {
          iconSpan.className = newVal ? "mdi mdi-circle" : "mdi mdi-circle-outline";
        }

        if (newVal) {
          this.onDrawRadiusClicked(); // Add circles
        } else {
          this.mapLayerGroups['radius'].clearLayers(); // Remove circles
        }
      },
      { immediate: true }
    );
  },
  filters: {
    numeric: function (value) {
      if (!value) return '';
      const newVal = value; // parseFloat(value.toString()).toFixed(6);
      return newVal;
    }
  },
  methods: {

    /**
     * Filter GPS points so that only the ones between the time range (hour in day to hour in day)
     * @param startHour 
     * @param endHour 
     */
    filterGpsByTime: function(startHour, endHour) {
      const me = this;
      const gpsLayerGroup = me.mapLayerGroups['laptopGpsPoints'];
      
      if (!gpsLayerGroup) return;

      gpsLayerGroup.eachLayer((marker) => {
        if (!marker?.feature?.properties) return;
        if (!marker._icon) return;

        const timeString = marker.feature.properties.Time; // e.g., "2026-04-21 09:43 PM PDT"
        if (!timeString) return;

        let hour = null;

        // Bulletproof Matcher for "HH:mm AM/PM" variations
        const match = timeString.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
        
        if (match) {
          let extractedHour = parseInt(match[1], 10);
          const ampm = match[3].toUpperCase();
          
          // Convert standard 12-hour values cleanly to a 24-hour spectrum (0-23)
          if (ampm === 'PM' && extractedHour < 12) extractedHour += 12;
          if (ampm === 'AM' && extractedHour === 12) extractedHour = 0;
          
          hour = extractedHour;
        } else {
          // Emergency native fallback logic if string structure shifts
          const pointDate = new Date(timeString);
          if (!isNaN(pointDate.getTime())) {
            hour = pointDate.getHours();
          }
        }

        // Skip the current marker if parsing returned no valid integer metric
        if (hour === null || isNaN(hour)) return;

        // Check if hour falls within the user's defined dashboard boundaries
        const isWithinTimeRange = hour >= startHour && hour < endHour;

        if (isWithinTimeRange) {
          marker._icon.classList.remove('hide-marker');
          if (marker._shadow) marker._shadow.classList.remove('hide-marker');
        } else {
          marker._icon.classList.add('hide-marker');
          if (marker._shadow) marker._shadow.classList.add('hide-marker');
        }
      });
    },    

    /**
     * Display all of the GPS points that were hidden with the show time slice function: filterGpsByTime 
     */
    resetTimeFilter: function() {
      //Set me reference to this LeafletMap component instance...
      const me = this;

      const gpsLayerGroup = me.mapLayerGroups['laptopGpsPoints'];
      
      if (!gpsLayerGroup) return;

      gpsLayerGroup.eachLayer((marker) => {
        if (marker._icon) {
          marker._icon.classList.remove('hide-marker');
        }
        if (marker._shadow) {
          marker._shadow.classList.remove('hide-marker');
        }
      });
    },

    /**
     * Initializes the markers to be added to\displayed on the map for the EAGLE task(s)
     */
    prepareMap: function () {
      //Set me reference to this LeafletMap component instance...
      const me = this;

      if (me.mapTrackPopup) {
        me.myMap.closePopup(me.mapTrackPopup);
      }

      let features = this.mapTasksData;

      // Check for alt addresses and add them to the
      let alt_address = mapMarkerService.getAlternateAddresses(features);
      if (alt_address.length > 0) {
        for (let i = 0; i < alt_address.length; i++) {
          features.push(alt_address[i]);
        }
      }

      // filter tasks from the list of features
      me.unsortedTasks = mapMarkerService.getUnsortedTasks(features);

      // order by allTasks
      me.allTasks = me.unsortedTasks.sort((a, b) => {
        b.DateCOMPLETEDMilli - a.DateCOMPLETEDMilli
      });

      // get suspect task count
      if (me.allTasks) {
        me.SuspectTasksCount = me.allTasks.filter((feature) => {
          return feature.tag === TASK_CONSTANTS.TASK_TAGS.SUSPECT;
        }).length;
      }

      const fnBoundPopupHandler = me.popUp.bind(me);
      let sortedMarkers = mapMarkerService.sortTaskRelatedFeatures(features);

      me.TASK_LAYER_NAMES.forEach((layerName) => {
        let fnGetMarkers;
        switch (layerName) {
          case 'home':
            fnGetMarkers = mapMarkerService.getHomeAddressMarkers;
            break;
          case 'erocTasks':
            fnGetMarkers = mapMarkerService.getErocTaskMarkers;
            break;
          case 'mrocTasks':
            fnGetMarkers = mapMarkerService.getMrocTaskMarkers;
            break;
          case 'noDataTasks':
            fnGetMarkers = mapMarkerService.getNoDataTaskMarkers;
            break;
          case 'tasks':
            fnGetMarkers = mapMarkerService.getTaskMarkers;
            break;
          case 'validTasks':
            fnGetMarkers = mapMarkerService.getValidTaskMarkers;
            break;
          case 'validTasksAlternativeLocation':
            fnGetMarkers = mapMarkerService.getValidTaskAlternativeLocationMarkers;
            break;
          case 'suspectTasks':
            fnGetMarkers = mapMarkerService.getSuspectTaskMarkers;
            break;
          case 'other':
            fnGetMarkers = mapMarkerService.getOtherMarkers;
            break;
          default: //polys
            fnGetMarkers = mapMarkerService.getPolyMarkers;
            break;
        }

        if (sortedMarkers[layerName]) {
          me.mapLayerGroups[layerName] = fnGetMarkers(sortedMarkers[layerName], fnBoundPopupHandler);
          if (me.mapLayerGroups[layerName]) {
            me.myMap.addLayer(me.mapLayerGroups[layerName]);
          }
        }
      });

      // add the tasks to a map with their ID as the key to id-task info pair
      this.tasksMap = {};
      if (this.mapTasksData && this.mapTasksData.length > 0) {
        this.mapTasksData.forEach((feature) => {
          this.tasksMap[feature.id] = feature;
        });
      }

      // If we have a valid map instance, apply all of
      // the markers to the map (show\display)
      if (this.myMap) {
        me.fitAllBoundsOnMap(features);
      }
    },

    /**
     * Clears the map of all markers
     *
     * @param evt
     */
    resetMap: function (evt) {
      this.$store.commit(this.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING, false);

      //Set me reference to this LeafletMap component instance...
      const me = this;

      for (let key in me.mapLayerGroups) {
        if (me.mapLayerGroups[key]) {
          me.myMap.removeLayer(me.mapLayerGroups[key]);
          me.mapLayerGroups[key].off("click");    // remove any click handling at the group level
          me.mapLayerGroups[key] = L.layerGroup();
        }
      }

      // Remove any travel line arrows that were added to the map
      for (const key in me.mapLayerTravelLineArrows) {
        let arrowLayers = me.mapLayerTravelLineArrows[key];
        if (arrowLayers && arrowLayers.length) {
          arrowLayers.forEach((arrowLayer) => {
            me.myMap.removeLayer(arrowLayer);
          });
        }

        // Clear the array out
        me.mapLayerTravelLineArrows[key] = [];
      }

      // Clear any address lookups from the map
      if (this.foundAddressMarkers && this.foundAddressMarkers.length > 0) {
        this.foundAddressMarkers.forEach((marker) => {
          me.myMap.removeLayer(marker);
        });
        this.foundAddressMarkers = [];
      }

      this.tasksMap = {};

      this.fitAllBoundsOnMap();
    },

    /**
     * Called when the trasks store 'clearMapData' action is dispatched
     * @param {*} data
     */
    onClearDataFromMapHandler() {
      this.mapTasksData = null;
      this.allBounds = null;
      this.allPoints = null;
      this.showClosestClusterClicked = false;
      // Since we're clearing the markers from the map, we are no longer zoomed in
      this.isZoomedIn = false;
      if (this.myMap) {
        this.resetMap();
        this.areDayTracksLoaded = false;
      }
    },

    /**
     * Called when the tracks store 'setTaskFeatures' action is dispatched
     * @param {*} data
     */
    onAddTasksDataToMapHandler(data) {
      this.mapTasksData = data;
      this.allPoints = this.getAllPoints(this.mapTasksData, true);
      this.allBounds = this.allPoints.getBounds();

      if (this.myMap) {
        this.dayTracksControl.addTo(this.myMap); //  add reset control to the map
        this.resetMap();
        this.prepareMap();
        this.myMap.fitBounds(this.allBounds,
          {
            animate: false,
            padding: [25, 25]
          }
        );
      }
    },

    /**
     * Handler for when a task/point is selected from outside the component
     * @param {*} pointId
     */
    onPointSelectedHandler(pointId) {
      const taskInfo = this.tasksMap[pointId];
      if (taskInfo) {
        this.onShowViewPoint(taskInfo);
      }
    },

    /**
     * Handler to add cluster data to the map
     * @param {*} clusters
     */
    onAddClustersDataToMapHandler(clusters) {
      const features = (clusters.cluster) ? [clusters.cluster] : clusters.features;
      if (features) {
        this.onLoadClusterMapData(features, true);
      }
    },

    onAddTaskTracksDataToMapHandler(taskTracks) {
      const trackData = taskTracks;
      let features = [];
      for (const key in trackData) {
        features = features.concat(trackData[key]);
      }

      // If we have already loaded the day tracks, there is no need to
      // add the task layers/markers to the map, so just zoom in...
      if (this.areDayTracksLoaded) {
        // Set the zoom/view of the map to fit the bounds for all the points on the map
        this.fitAllBoundsOnMap(features);
        this.$store.commit(this.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING, false);
      } else {  // Add the task layers/markers to the map
        if (features && this.myMap && this.mapLayerGroups) {
          this.onLoadTrackMapData(features, false);
        }
      }
    },

     /**
     * Handler which adds tracks for the day (clusters, stops, gps, etc.) to the map
     * @param {*} dayTracks
     */
    onAddDayTracksDataToMapHandler(dayTracks, bClearMap, events) {
      if (bClearMap) {
        this.onClearDataFromMapHandler();
        this.dayTracksControl.remove();
      }
      if (!this.areDayTracksLoaded) {
        console.log(dayTracks.length + ' layers being added........');
        const trackData = dayTracks;
        if (trackData && this.myMap && this.mapLayerGroups) {
          const me = this;  // Scope this here

          // NEW: Work out the study/staff for this day so we can load the staff home.
          // Events carry studyCode/staffId; fall back to the track features if there are no events
          const firstEvent = (events && events.length) ? events[0] : null;
          const firstTrackProps = (trackData.length && trackData[0].properties) ? trackData[0].properties : {};
          const study = firstEvent?.studyCode || firstTrackProps.studyCode || firstTrackProps.StudyCode;
          const staffId = firstEvent?.staffId || firstTrackProps.staffId || firstTrackProps.StaffId;

          // NEW: Reset any cached staff home from a previous day
          me.staffHomeAddress = null;

          // NEW: Fetch the staff home, tag it as HOME and add it to the track data so
          // onLoadTrackMapData draws it (shown in both events and tracks views)
          const homePromise = (study && staffId)
            ? staffService.getStaffHome({ study, staffId })
              .then(response => {
                const homeFeatures = response?.data?.features || [];
                if (homeFeatures.length) {
                  const p = homeFeatures[0].properties || {};
                  me.staffHomeAddress = `${p.StreetAddress} ${p.PlaceName}, ${p.AdminAreaCode} ${p.PostCode}`;
                }
                return homeFeatures.map(f => ({
                  ...f,
                  properties: { ...f.properties, tag: TASK_CONSTANTS.TASK_TAGS.HOME }
                }));
              })
              .catch(err => {
                console.error('Failed to load staff home', err);
                return [];
              })
            : Promise.resolve([]);

          // NEW: Load tracks (plus staff home) once the home request finishes
          homePromise.then(homeFeatures => {
            me.onLoadTrackMapData(trackData.concat(homeFeatures), true);
          });
          this.areDayTracksLoaded = true;

          let eventMarkers = mapMarkerService.getClientEventMarkers(events);
          if (eventMarkers) {
            if (me.mapViewModel['events']) {
              me.mapLayerGroups['events'] = eventMarkers;
              if (me.mapLayerGroups['events']) {
                me.myMap.addLayer(me.mapLayerGroups['events']);
                me.mapLayerGroups['events'].on('click', (evt) => {
                const source = evt.sourceTarget;
                const props = source.feature.properties;

                // NEW: Reuse the staff home address we already loaded
                if (me.staffHomeAddress) {
                  props.staffAddress = me.staffHomeAddress;
                  me.showTrackPopup(
                    source.getLatLng(),
                    mapMarkerService.getClientEventPopupContent(props)
                  );
                  return;
                }

                const study = props.studyCode;
                const staffId = props.staffId;
                staffService.getStaffHome({ study, staffId })
                  .then(response => {
                    let address = "No Data";

                    if (response?.data?.features?.length) {
                      const p = response.data.features[0].properties;
                      address = `${p.StreetAddress} ${p.PlaceName}, ${p.AdminAreaCode} ${p.PostCode}`;
                    }
                    props.staffAddress = address;
                    me.showTrackPopup(
                    source.getLatLng(),
                    mapMarkerService.getClientEventPopupContent(props)
                    );
                  })
                  .catch(err => {
                    props.staffAddress = "No Data";
                    me.showTrackPopup(
                      source.getLatLng(),
                      mapMarkerService.getClientEventPopupContent(props)
                    );
                  });
                });
              }
            }
          }
        }
      } else {
        // If we're zoomed in, no need to fit to bounds...
        if (!this.isZoomedIn) {
          this.fitAllBoundsOnMap(dayTracks);
        }
        this.$store.commit(this.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING, false);
      }
    },

    /**
     * Show an info popup from a specific point on the map
     */
    onShowViewPoint(taskData) {
      const fnIsValidStatus = function (status) {
        return (status === TASK_CONSTANTS.TASK_STATUS.VALID || status === TASK_CONSTANTS.TASK_STATUS.COMPLETED ||
          status === TASK_CONSTANTS.TASK_STATUS.UNDER_REVIEW || status === TASK_CONSTANTS.TASK_STATUS.CORRECTED);
      };
      const task = taskData.properties;
      // DD - Original code from taskClick method
      if (task.tag === TASK_CONSTANTS.TASK_TAGS.TASK || task.tag === TASK_CONSTANTS.TASK_TAGS.VALID_ALT) {
        if (fnIsValidStatus(task.Status)) {
          if (task.TaskType === TASK_CONSTANTS.TASK_TYPES.EROC) {
            if (this.mapLayerGroups && this.mapLayerGroups.erocTasks) {
              this.showTaskPopup(this.mapLayerGroups.erocTasks.getLayers(), task);
            }
          } else if (task.TaskType === TASK_CONSTANTS.TASK_TYPES.MROC) {
            if (this.mapLayerGroups && this.mapLayerGroups.mrocTasks) {
              this.showTaskPopup(this.mapLayerGroups.mrocTasks.getLayers(), task);
            }
          } else {
            const alternateLocation = ( task?.tag === TASK_CONSTANTS.TASK_TAGS.VALID_ALT || task?.AlternateLocation === true || task?.alternateLocation === true);
            if (alternateLocation) {
              if (this.mapLayerGroups && this.mapLayerGroups.validTasksAlternativeLocation) {
                this.showTaskPopup(this.mapLayerGroups.validTasksAlternativeLocation.getLayers(), task);
              }
            } else {
              if (this.mapLayerGroups && this.mapLayerGroups.validTasks) {
                this.showTaskPopup(this.mapLayerGroups.validTasks.getLayers(), task);
              }
            }
          }
        } else {
          if (this.mapLayerGroups && this.mapLayerGroups.tasks) {
            this.showTaskPopup(this.mapLayerGroups.tasks.getLayers(), task);
          }
        }
      } else if (task.tag === TASK_CONSTANTS.TASK_TAGS.SUSPECT || task.tag === TASK_CONSTANTS.TASK_TAGS.SUSPECT_ALT) {
        if (this.mapLayerGroups && this.mapLayerGroups.suspectTasks) {
          this.showTaskPopup(this.mapLayerGroups.suspectTasks.getLayers(), task);
        }
      } else if (task.tag === TASK_CONSTANTS.TASK_TAGS.NO_DATA || task.tag === TASK_CONSTANTS.TASK_TAGS.NO_DATA_ALT) {
        if (this.mapLayerGroups && this.mapLayerGroups.noDataTasks) {
          this.showTaskPopup(this.mapLayerGroups.noDataTasks.getLayers(), task);
        }
      } else if (task.tag === TASK_CONSTANTS.TASK_TAGS.OTHER) {
        if (this.mapLayerGroups && this.mapLayerGroups.other) {
          this.showTaskPopup(this.mapLayerGroups.other.getLayers(), task);
        }
      }
    },

    /**
     * Call to display a task info popup.
     *
     * @param layers - collection of layers on the map which contains the task marker to display
     * @param task - task instance off the info popup to be displayed
     */
    showTaskPopup: function (layers, task) {
      let marker = layers.find((layer) => layer.feature.id === task.TaskUUID);

      if (marker) {
        marker.openPopup();
      }
    },

    /**
     * Phone travel line arrows
     */
    phoneArrows: function (feature, layer) {
      this.mapLayerTravelLineArrows.phone.push(L.polylineDecorator(layer, {
        renderer: L.canvas(),
        patterns: [{
          offset: 100,
          repeat: 200,
          symbol: L.Symbol.arrowHead({
            pixelSize: 15,
            pathOptions: {
              fillOpacity: 1,
              color: '#e77504',
              weight: 2,
              opacity: 1,
              zIndex: 1
            }
          })
        }]
      }));
    },

    /**
     * Laptop travel line arrows
     */
    arrows: function (feature, layer) {
      this.mapLayerTravelLineArrows.laptop.push(L.polylineDecorator(layer, {
        renderer: L.canvas(),
        patterns: [{
          offset: 5,
          repeat: 50,
          symbol: L.Symbol.arrowHead({
            pixelSize: 15,
            pathOptions: {
              fillOpacity: 1,
              color: '#0089f7',
              weight: 2,
              opacity: 1,
              zIndex: 1
            }
          })
        }]
      }));
    },

    /**
     * Create a task info popup and add it to the map.
     * @param - feature
     * @param - layer
     */
    popUp(feature, layer) {
      let featureData = feature;
      let tag = featureData.properties.tag;
      let tableData = featureData.properties;
      let tableTemplate;

      // const num = (tableData.ClusterDistance) ? tableData.ClusterDistance * 0.000621371 : 0;

      let staffId = (tableData.StaffId) ? tableData.StaffId : 'No Data',
        staffName = (tableData.StaffName) ? tableData.StaffName : 'No Data',
        duid = (tableData.DUID) ? tableData.DUID : 'No Data',
        spid = (tableData.SPID) ? tableData.SPID : 'No Data',
        taskUuid = (tableData.TaskUUID) ? tableData.TaskUUID : 'No Data',
        taskType = (tableData.TaskType) ? tableData.TaskType : 'No Data',
        taskLabel = (tableData.TaskLabel) ? tableData.TaskLabel : 'No Data',
        dispositionCode = (tableData.DispositionCode) ? tableData.DispositionCode : 'No Data',
        dispositionLabel = (tableData.DispositionLabel) ? tableData.DispositionLabel : 'No Data',
        comment = (tableData.Comment) ? tableData.Comment : 'No Data',
        dateCOMPLETED = (tableData.DateCOMPLETED) ? tableData.DateCOMPLETED : 'No Data',
        status = (tableData.Status) ? tableData.Status : 'No Data',
        statusBasis = (tableData.StatusBasis) ? tableData.StatusBasis : 'No Data',
        distance = (tableData.ClusterDistance) ? tableData.ClusterDistance : 'No Data',
        geoPrecision = (tableData.GeoPrecision) ? tableData.GeoPrecision : 'No Data',
        geoMatchType = (tableData.GeoMatchType) ? tableData.GeoMatchType : 'No Data',
        region = (tableData.Region) ? tableData.Region : 'No Data',
        psu = (tableData.PSU) ? tableData.PSU : 'No Data',
        segment = (tableData.Segment) ? tableData.Segment : 'No Data',
        wave = (tableData.Wave) ? tableData.Wave : 'No Data',
        streetAddress = (tableData.StreetAddress) ? tableData.StreetAddress : 'No Data',
        placeName = (tableData.PlaceName) ? tableData.PlaceName : 'No Data',
        adminAreaCode = (tableData.AdminAreaCode) ? tableData.AdminAreaCode : 'No Data',
        postCode = (tableData.PostCode) ? tableData.PostCode : 'No Data',
        startDate = (tableData.StartDate) ? tableData.StartDate : 'No Data',
        endDate = (tableData.EndDate) ? tableData.EndDate : 'No Data',
        startTime = (tableData.DateStart) ? tableData.DateStart : 'No Data',
        endTime = (tableData.DateEnd) ? tableData.DateEnd : 'No Data',
        points = (tableData.Points) ? tableData.Points : 'No Data',
        clusterId = (tableData.ClusterId) ? tableData.ClusterId : 'No Data';

      let duration = (tableData.ClusterDuration) ? tableData.ClusterDuration : 'No Data';
      //Duration
      if (duration) {
        let parts = duration.split(' ');
        duration = parts[0] + 'h ' + parts[1] + 'm ' + parts[2] + 's';
      }

      // The altenative adress info
      let altInterviewLocation = (tableData.AltInterviewLocation) ? tableData.AltInterviewLocation : 'No Data';
      let altInterviewFullAddress = "No Data"
      if (tableData.AltInterviewAddress) {
        altInterviewFullAddress = (tableData.AltInterviewAddress.streetAddress || '') + " \n" + (tableData.AltInterviewAddress.placeName || '') + ", " + (tableData.AltInterviewAddress.adminArea || '') + " " + (tableData.AltInterviewAddress.postCode || '');
      }
      let altLat = "No Data", altLon = "No Data";
      if (tableData.AltInterviewAddress && tableData.AltInterviewAddress.point) {
        altLat = tableData.AltInterviewAddress.point.lat;
        altLat = altLat.toFixed(2);

        altLon = tableData.AltInterviewAddress.point.lon;
        altLon = altLon.toFixed(2);
      }

      if (tag === TASK_CONSTANTS.TASK_TAGS.TASK || tag === TASK_CONSTANTS.TASK_TAGS.VALID_ALT ||
        tag === TASK_CONSTANTS.TASK_TAGS.SUSPECT || tag === TASK_CONSTANTS.TASK_TAGS.SUSPECT_ALT ||
        tag === TASK_CONSTANTS.TASK_TAGS.NO_DATA || tag === TASK_CONSTANTS.TASK_TAGS.NO_DATA_ALT ||
        tag === TASK_CONSTANTS.TASK_TAGS.OTHER) {
        tableTemplate = '<table class="popup-table">' +
          '<tbody>' +
          '<tr class="even">' +
          '<th>Staff ID</th>' +
          '<td>' + staffId + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th>Staff Name</th>' +
          '<td>' + staffName + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<th>DUID</th>' +
          '<td data-cy="map-task-popup-duid">' + duid + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th>SPID</th>' +
          '<td data-cy="map-task-popup-spid">' + spid + '</td>' +
          '</tr>' +

          '<tr class="even">' +
          '<th>Task Type</th>' +
          '<td>' + taskType + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> Task Label</th>' +
          '<td>' + taskLabel + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<th> Disposition Code</th>' +
          '<td>' + dispositionCode + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> Disposition Label</th>' +
          '<td>' + dispositionLabel + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<th> Comment</th>' +
          '<td v-bind-html="' + comment + '"></td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> Completed Date</th>' +
          '<td>' + dateCOMPLETED + '</td>' +
          '</tr>';

        if (tableData.PointCompleted && tableData.PointCompletedType === 'LAPTOP') {
          tableTemplate += '<tr class="even">' +
            '<th> Closest GPS Point</th>' +
            '<td><img data-cy="closest-point" id="gpspoint-' + tableData.PointCompleted + '" onclick="let testEvent = new CustomEvent(\'eagle_map_event\', { bubbles: true, detail: { type: 3, pointId: \'' + tableData.PointCompleted + '\' }}); document.getElementById(\'gpspoint-' + tableData.PointCompleted + '\').dispatchEvent(testEvent);" class="popup-table-img" src="' + this.legendIcons.laptopClosest + '"/></td>' +
            '</tr>';
        }

        if (tableData.PointCompleted && tableData.PointCompletedType === 'PHONE') {
          tableTemplate += '<tr class="even">' +
            '<th> Closest GPS Point</th>' +
            '<td><img data-cy="closest-point" id="gpspoint-' + tableData.PointCompleted + '" onclick="let testEvent = new CustomEvent(\'eagle_map_event\', { bubbles: true, detail: { type: 3, pointId: \'' + tableData.PointCompleted + '\' }}); document.getElementById(\'gpspoint-' + tableData.PointCompleted + '\').dispatchEvent(testEvent);" class="popup-table-img" src="' + this.legendIcons.phoneClosest + '"/></td>' +
            '</tr>';
        }

        tableTemplate += '<tr class="even">' +
          '<th> Status</th>' +
          '<td>' + status + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> Status Basis</th>' +
          '<td>' + statusBasis + '</td>' +
          '</tr>' +
          // '<tr class="even">' +
          //     '<th> Geo Precision</th>' +
          //     '<td>' + geoPrecision + '</td>' +
          // '</tr>';
          '<tr class="even">' +
          '<th> Geo Match Type</th>' +
          '<td>' + geoMatchType + '</td>' +
          '</tr>';

        if (tableData.ClusterId && tableData.ClusterType === 'FIELD') {
          tableTemplate += '<tr class="even">' +
            '<th> Cluster</th>' +
            '<td><img data-cy="closest-cluster" id="cluster-' + tableData.ClusterId + '" onclick="let testEvent = new CustomEvent(\'eagle_map_event\', { bubbles: true, detail: { type: 2, clusterId: \'' + tableData.ClusterId + '\' }}); document.getElementById(\'cluster-' + tableData.ClusterId + '\').dispatchEvent(testEvent);" class="popup-table-img" src="' + this.legendIcons.cluster + '"/></td>' +
            '</tr>';
        }

        if (tableData.ClusterId && tableData.ClusterType === 'STOP') {
          tableTemplate += '<tr class="even">' +
            '<th> Cluster</th>' +
            '<td><img data-cy="closest-cluster" id="cluster-' + tableData.ClusterId + '" onclick="let testEvent = new CustomEvent(\'eagle_map_event\', { bubbles: true, detail: { type: 2, clusterId: \'' + tableData.ClusterId + '\' }}); document.getElementById(\'cluster-' + tableData.ClusterId + '\').dispatchEvent(testEvent);" class="popup-table-img" src="' + this.legendIcons.phoneStop + '"/></td>' +
            '</tr>';
        }

        tableTemplate += '<tr class="even">' +
          '<th> Cluster Distance</th>' +
          '<td>' + distance + ' mile(s)</td>' +
          '</tr>';

        // Matthew didnt specify if he wants in here too
        // if (tableData.ClusterId) {
        //   tableTemplate += '<tr class="even">' +
        //       '<th> Cluster Id </th>' +
        //       '<td>' + tableData.ClusterId + '</td>' +
        //   '</tr>';
        // }

        tableTemplate += '<tr class="even">' +
          '<th> Precision</th>' +
          '<td>' + geoPrecision + '</td>' +
          '</tr>';

        // The alternative address in red only if AlternateLocation is true
        if (tableData.AlternateLocation) {
          tableTemplate += '<tr class="even" style="background-color: mistyrose;">' +
            '<th> Interview Location</th>' +
            '<td>' + altInterviewLocation + '</td>' +
            '</tr>';
          tableTemplate += '<tr class="even" style="background-color: mistyrose;">' +
            '<th> Interview Address</th>' +
            '<td>' + altInterviewFullAddress + '</td>' +
            '</tr>';
          tableTemplate += '<tr class="even" style="background-color: mistyrose;">' +
            '<th> Interview Geo Location</th>' +
            '<td>' + "lat: " + altLat + " lon: " + altLon + '</td>' +
            '</tr>';
        }

        tableTemplate += '<tr class="even">' +
          '<th> Region</th>' +
          '<td>' + region + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> PSU</th>' +
          '<td>' + psu + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<th> Segment</th>' +
          '<td>' + segment + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> Wave</th>' +
          '<td>' + wave + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<th>Task UUID</th>' +
          '<td data-cy="map-task-popup-uuid">' + taskUuid + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th>Tracks</th>' +
          '<td><img data-cy="track-points" id="taskpoint-' + taskUuid + '" onclick="let testEvent = new CustomEvent(\'eagle_map_event\', { bubbles: true, detail: { type: 1, taskId: \'' + taskUuid + '\' }}); document.getElementById(\'taskpoint-' + taskUuid + '\').dispatchEvent(testEvent);" class="popup-table-img" src="' + this.legendIcons.laptop + '"/></td>' +
          '</tr>' +
          '</tbody>' +
          '</table>';
      }
      if (tag === TASK_CONSTANTS.TASK_TAGS.HOME) {
        tableTemplate = '<table class="popup-table">' +
          '<tbody>' +
          '<tr class="even">' +
          '<th> Staff ID</th>' +
          '<td>' + staffId + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> Staff Name</th>' +
          '<td>' + staffName + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<th> Address</th>' +
          '<td>' + streetAddress + '<br>' + placeName + '&nbsp;' + adminAreaCode + '&nbsp;' + postCode + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> Region</th>' +
          '<td>' + region + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<th> Start Date</th>' +
          '<td>' + startDate + '</td>' +
          '</tr>' +
          '<tr class="odd" v-if="tableData.DateEnd">' +
          '<th> End Date</th>' +
          '<td>' + endDate + '</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>';
      }

      if (tag === TASK_CONSTANTS.TASK_TAGS.CLUSTER) {
        tableTemplate = '<table class="popup-table">' +
          '<tbody>' +
          '<tr class="even">' +
          '<th> Staff ID</th>' +
          '<td>' + staffId + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> Staff Name</th>' +
          '<td>' + staffName + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<th> Duration</th>' +
          '<td>' + duration + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> Start Time</th>' +
          '<td>' + startTime + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<th> End Time</th>' +
          '<td>' + endTime + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> GPS Points</th>' +
          '<td>' + points + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<th> Cluster Id</th>' +
          '<td>' + clusterId + '</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>';
      }

      if (tag === TASK_CONSTANTS.TASK_TAGS.STOP_POINTS) {
        tableTemplate = '<table class="popup-table">' +
          '<tbody>' +
          '<tr class="even">' +
          '<td> Staff ID</td>' +
          '<td>' + staffId + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<td> Staff Name</td>' +
          '<td>' + staffName + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<td> Duration</td>' +
          '<td>' + duration + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<td> Start Time</td>' +
          '<td>' + startTime + '</td>' +
          '</tr>' +
          '<tr class="even">' +
          '<td> End Time</td>' +
          '<td>' + endTime + '</td>' +
          '</tr>' +
          '<tr class="odd">' +
          '<td> GPS Points</td>' +
          '<td>' + points + '</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>';
      }
      const template = '<div class="popup-content">' +
        tableTemplate + '</div>';

      layer.bindPopup(template);
    },

    /**
     * Event click handler for closest GPS point on task info popup. Displays the popup
     * for the GPS point.
     *
     * @param id - the id for the GPS point
     */
    onShowClosestGPS(id) {
      if (id) {
        // Set this with the layer that has the id we're looking for...
        let foundLayer;
        // Layer names to check
        const CLOSEST_GPS_LAYER_NAMES = ['laptopClosestGpsPoint', 'phoneClosestGpsPoint'];
        for (let idx = 0; idx < CLOSEST_GPS_LAYER_NAMES.length; idx++) {

          // If we've found a layer, no more looking
          if (foundLayer) {
            break;
          }

          const layerName = CLOSEST_GPS_LAYER_NAMES[idx];
          if (this.mapLayerGroups[layerName]) {
            let layers = this.mapLayerGroups[layerName].getLayers();
            if (layers && layers.length > 0) {
              // See if a layer has the id we're looking for
              foundLayer = layers.find((layer) => id === layer.feature.id);
            }
          }
        }

        // open gps point details if we have found the layer for the point
        this.showLayerPopup(foundLayer, this.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE.GET_GPS_POINT_BY_ID, { study: this.study, id: id }, 'gps');
      }
    },

    /**
     * Event click handler for cluster point on task info popup. Displays the popup
     * for the GPS point.
     *
     * @param id - the id for the cluster
     */
    onShowClosestCluster(id) {
      if (id) {
        let foundLayer;
        const len = this.CLUSTER_LAYER_NAMES.length;
        for (let idx = 0; idx < len; idx++) {
          // If we've found a layer, no more looking
          if (foundLayer) {
            break;
          }
          const layerName = this.CLUSTER_LAYER_NAMES[idx];
          if (this.mapLayerGroups[layerName]) {
            let layers = this.mapLayerGroups[layerName].getLayers();
            if (layers && layers.length > 0) {
              // See if a layer has the id we're looking for
              foundLayer = layers.find((layer) => layer.feature.id === id || layer.feature.properties.ClusterId === id);
            }
          }
        }

        // open cluster point details
        this.showLayerPopup(foundLayer, this.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE.GET_CLUSTER_BY_ID, { study: this.study, clusterId: id }, 'clusters');
      }
    },

    /**
     * Handles the display of a popup from a map event. If the layers have alreaday been loaded (day tracks)
     * the layer param should be valid (not null) and the popup displayed without loading anything. If the layer
     * param is null, then we need to make a call to load the layer/marker and add it to the map before displaying
     * the popup for the layer/marker.
     *
     * @param {*} layer - map layer/marker to show the popup for. If it's null,
     * then we'll make a call to API to get the geo json info and load it on the map
     * @param {*} storeAction - store action to invoke if the layer param is null. This action
     * will call the API to load the geo json, which will be loaded on the map as part of this
     * method
     * @param {*} criteria - criteria for the store action
     */
    showLayerPopup(layer, storeAction, criteria) {

      // Check if we're trying to show info for a cluster or a GPS point
      let isCluster = (storeAction === this.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE.GET_CLUSTER_BY_ID),
        // We use different methods to build popup content, so
        // use the correct popup content building function
        buildPopupContentFunction = (isCluster) ?
          mapMarkerService.getClusterPopupContent :
          mapMarkerService.getTrackPopupContent;

      //Set me reference to this LeafletMap component instance...
      const me = this;
      // Request the geo json data from the API
      me.$store.dispatch(storeAction, criteria).then((results) => {
        const feature = (isCluster) ? results.cluster : results.point;
        // Load the features on the map & open the popup
        if (feature) {
          // If a layer wasn't passed in then the layer group wasn't loaded so we need to request the
          // geo JSON data from the API and add it to the map before we can display the popup.
          if (!layer) {
            // Loading features on the map...
            if (isCluster) {
              me.onLoadClusterMapData([feature], me.showClosestClusterClicked);
            } else {
              me.onLoadTrackMapData([feature], me.showClosestClusterClicked);
            }
          }
          // Showing popup...
          const latLng = L.latLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
          // Set that we've zoomed in to look at closest cluster/point
          me.isZoomedIn = true;
          // Set the map view to center on the specified latlng and zoom all the way in
          me.myMap.flyTo(latLng, me.myMap.getMaxZoom(), { animate: false });
          // Display the popup
          me.showTrackPopup(latLng, buildPopupContentFunction(feature.properties));
        }
      })
        .catch((err) => {
          console.error(err);
        });
    },

    /** Add radius circles for valid tasks */
    onDrawRadiusClicked() {
      const me = this;

      me.mapLayerGroups['radius'].clearLayers();

      for (const key in me.mapTasksData) {
        const task = me.mapTasksData[key];
        const precision = task.properties.Precision ?? 250;
        const latLng = L.latLng(task.geometry.coordinates[1], task.geometry.coordinates[0]);
        let color;

        if (task.properties.Status === 'VALID') {
          color = 'green';
        } else if (task.properties.Status === 'SUSPECT') {
          color = 'red';
        } else if (task.properties.Status === 'UNKNOWN') {
          color = 'purple';
        } else if (task.properties.Status === 'UNDER_REVIEW') {
          color = 'teal';
        } else {
          continue;
        }

        const circle = L.circle(latLng, {
          radius: 2 * precision,
          color: color,
          fillOpacity: 0.1,
        });

        me.mapLayerGroups['radius'].addLayer(circle);
      }
    },

    /**
     * Handles enabling/disabling full screen mode for the map
     */
    onFullScreenClicked(isFullScreen) {
      let elem = document.getElementById(this.myMapId);
      let ctrlElem = document.getElementById(this.myMapId + '-full-screen')
      if (isFullScreen) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Edge, Safari */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE11 */
          elem.msRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* Firefox */
          elem.mozRequestFullscreen();
        }
        ctrlElem.classList.remove('mdi-arrow-expand-all');
        ctrlElem.classList.add('mdi-arrow-collapse-all');
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Chrome, Edge, Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
          document.msExitFullscreen();
        } else if (document.msExitFullscreen) { /* Firefox */
          document.mozExitFullscreen();
        }
        ctrlElem.classList.remove('mdi-arrow-collapse-all');
        ctrlElem.classList.add('mdi-arrow-expand-all');
      }
    },

    /**
     * Loads clusters and stop points for laptops/phones
     * @param {*} features
     * @param {*} bClearMapLayers
     */
    onLoadClusterMapData(features, bClearMapLayers = false) {
      const me = this;

      if (me.mapTrackPopup) {
        me.myMap.closePopup(me.mapTrackPopup);
      }

      // Bind the method to handle popups to the component here
      const fnBoundPopupHandler = me.popUp.bind(me);
      // Get map markers for the features
      let sortedFeatures = mapMarkerService.sortClusterFeatures(features);

      me.CLUSTER_LAYER_NAMES.forEach((layerName) => {
        let fnGetMarkers;
        switch (layerName) {
          case 'stopPoints':
            fnGetMarkers = mapMarkerService.getStopPointMarkers;
            break;
          default: //clusters
            fnGetMarkers = mapMarkerService.getClusterMarkers;
            break;
        }

        if (sortedFeatures[layerName]) {
          if (me.mapLayerGroups[layerName]) {
            const layers = me.mapLayerGroups[layerName].getLayers();

            // If we are not overriding the layer groups and if the layerGroup
            // already has layers, just add to layerGroup
            if (!bClearMapLayers && (layers && layers.length > 0)) {
              const featureLayer = fnGetMarkers(sortedFeatures[layerName], me.logMarkerInfo);
              featureLayer.eachLayer((layer) => {
                me.mapLayerGroups[layerName].addLayer(layer);
              });
            } else {
              if (!me.showClosestClusterClicked) {
                me.myMap.removeLayer(me.mapLayerGroups[layerName]);
                me.mapLayerGroups[layerName] = fnGetMarkers(sortedFeatures[layerName], me.logMarkerInfo);
              }
            }

            // Only add the clusters to the map if they are selected in the
            // filter/viewModel settings
            if (me.mapViewModel[layerName]) {
              me.myMap.addLayer(me.mapLayerGroups[layerName]);
              me.mapLayerGroups[layerName].on('click', (evt) => {
                //console.log('clicked a cluster/stop...');
                const source = evt.sourceTarget;

                // Only show for clusters and stop points. Do not show for 
                // "poly" lines.
                if (source.feature && source.feature.tag !== "poly") {
                  me.showTrackPopup(source.getLatLng(), mapMarkerService.getClusterPopupContent(source.feature.properties));
                }
              });
            }
          }
        }
      });

      me.showClosestClusterClicked = false;
    },

       /**
     * Loads track data (gps points, closest gps points and travel lines & arrows for laptop\phone)
     */
    onLoadTrackMapData(features, bClearMapLayers = false) {
      //If features are empty, disable loader
      if (!features || features.length === 0) {
        this.$store.commit(this.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING, false);
      }

      // Close any open popups
      if (this.mapTrackPopup) {
        this.myMap.closePopup(this.mapTrackPopup);
      }

      let points = [];

      // If there are any task related items already displayed on the map
      // such as: staff home or task location(s) add them to the points array
      if (this.mapTasksData) {
        points = points.concat(this.mapTasksData);
      }

      // Add the track related items that will be added to the map to
      // the points array
      points = points.concat(features);

      this.allPoints = L.geoJson(points);

      // Get map markers for tha track related items
      let sortedFeatures = mapMarkerService.sortDayTrackMarkers(features, this.allTasks);
      // Counter to keep track of how many layers/markers we have added to the map
      // this is used to disable the loader/spinner
      let layerCount = 0;

      const me = this;  //reference for this scoped for use inside layeradd event handler

      // Get the count of layers that will be added to the map based
      // on filter selections/mapViewModel
      let expectedAddedLayers = 0;
      me.TRACK_LAYER_NAMES.forEach((layerName) => {
        // Only add to the count if this layer should be displayed on the map
        // based on filter/mapViewModel settings
        if (me.mapViewModel[layerName]) {
          // If this layer has any markers, add the count to the
          // expected total added layers count
          if (sortedFeatures[layerName]) {
            expectedAddedLayers += sortedFeatures[layerName].length;
          }
        }
      });

      // NEW: Add the staff home marker(s) to the expected total added layers count
      const homeFeatures = sortedFeatures.home || [];
      if (homeFeatures.length > 0) {
        expectedAddedLayers += homeFeatures.length;
      }

      // If we aren't adding anything then just dismiss the loadig screen
      if (expectedAddedLayers === 0) {
        this.$store.commit(this.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING, false);
      }

      // Timeout to disable spinner in case something goes wrong with adding the markers to the map
      setTimeout(() => {
        me.myMap.off("layeradd");
        me.$store.commit(me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING, false);
      }, 25000);
      // Keep track of how many markers/layers have been added. Once we have added all that
      // were supposed to be added we will disable the loader/spinner
      this.myMap.on("layeradd", function (evt) {
        layerCount++;
        // See if we have added the expected number of layers and if we have dismiss
        // the loading screen
        if (layerCount === expectedAddedLayers) {
          me.myMap.off("layeradd");
          me.$store.commit(me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING, false);
        }
      });

      // on click handlers for gps and travel line markers
      const onClickHandlers = {
        'gpsPoints': function (evt) {
          const source = evt.sourceTarget;
          this.showTrackPopup(source.getLatLng(), mapMarkerService.LOADING_CONTENT);
          console.log('source: ', source)
          this.$store.dispatch(me.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE.GET_GPS_POINT_BY_ID, { id: source.feature.id }).then((results) => {
            if (results && results.point) {
              this.mapTrackPopup.setContent(mapMarkerService.getTrackPopupContent(results.point.properties));
            }
          })
            .catch((err) => {
              this.mapTrackPopup.setContent(mapMarkerService.getTrackPopupContent({}));
              console.error(err);
            });
        },
        'travelLines': function (evt) {
          if (evt && evt.layer) {
            if (evt.layer.feature.properties.tag === TASK_CONSTANTS.TASK_TAGS.LAPTOP_TRAVEL_LINES) {
              const style = (evt.layer.options.color === "#0089f7") ?
                MAP_CONSTANTS.TRACK_STYLES.laptopHighlightStyle :
                MAP_CONSTANTS.TRACK_STYLES.laptopDefaultStyle;
              evt.layer.setStyle(style);
            } else {
              const style = (evt.layer.options.color === "#e77504") ?
                MAP_CONSTANTS.TRACK_STYLES.phoneHighlightStyle :
                MAP_CONSTANTS.TRACK_STYLES.phoneDefaultStyle;
              evt.layer.setStyle(style);
            }
          }
        }
      };

      // If we are clearing layers...
      if (bClearMapLayers) {
        // Loop through the travel line arrow layer groups
        for (const key in this.mapLayerTravelLineArrows) {
          let arrowLayers = this.mapLayerTravelLineArrows[key];
          // If we have travel line arrow layers
          if (arrowLayers && arrowLayers.length > 0) {
            const me = this;
            // Remove the travel line arrows from the map.
            arrowLayers.forEach((arrowLayer) => {
              me.myMap.removeLayer(arrowLayer);
            });
          }
          this.mapLayerTravelLineArrows[key] = [];
        }

        // NEW: Remove the previous staff home marker(s) from the map
        if (this.mapLayerGroups['trackHome']) {
          this.myMap.removeLayer(this.mapLayerGroups['trackHome']);
          this.mapLayerGroups['trackHome'] = null;
        }
      }

      // Load the markers for laptop track features
      this.loadAndAddLaptopTrackMarkers(sortedFeatures, onClickHandlers, this.mapLayerTravelLineArrows.laptop, bClearMapLayers);
      // Load the markers for phone track features
      this.loadAndAddPhoneTrackMarkers(sortedFeatures, onClickHandlers, this.mapLayerTravelLineArrows.phone, bClearMapLayers);

      // NEW: Load the markers for the staff home
      if (homeFeatures.length > 0) {
        // NEW: Popup showing the home address when the home marker is clicked
        const homePopup = (feature, layer) => {
          layer.on('click', () => {
            const p = feature.properties || {};
            const address = (p.StreetAddress)
              ? `${p.StreetAddress} ${p.PlaceName}, ${p.AdminAreaCode} ${p.PostCode}`
              : 'No Data';
            me.showTrackPopup(layer.getLatLng(), `<strong>Interviewer Home</strong><br/>${address}`);
          });
        };
        this.mapLayerGroups['trackHome'] = mapMarkerService.getHomeAddressMarkers(homeFeatures, homePopup);
        this.myMap.addLayer(this.mapLayerGroups['trackHome']);
      }

      // If there was a selecteed popup open, close it here
      if (this.selectedPopup) {
        this.myMap.closePopup(this.selectedPopup);
      }

      // If we have zoomed into look at closest cluster/point, no need to fit bounds
      if (!this.isZoomedIn) {
        // Set the zoom/view of the map to fit the bounds for all the points on the map
        this.fitAllBoundsOnMap(features);
      }
    },

    /**
     * Create markers for laptop track data and add it to the map
     * LAPTOP_TRACK_LAYER_NAMES: ['laptopGpsPoints', 'laptopClosestGpsPoint', 'laptopTravelLines']
     * @param {*} sortedFeatures
     */
    loadAndAddLaptopTrackMarkers(sortedFeatures, onClickHandlers, arrows, bClearMapLayers = false) {
      const me = this;  //reference to this scoped for use in foreach
      this.LAPTOP_TRACK_LAYER_NAMES.forEach((layerName) => {
        let fnOnClick,
          getMarkersFunctionInfo;
        switch (layerName) {
          case 'laptopGpsPoints':
            fnOnClick = onClickHandlers.gpsPoints;
            getMarkersFunctionInfo = {
              fnGetMarkers: mapMarkerService.getLaptopGpsMarkers
            };
            break;
          case 'laptopClosestGpsPoint':
            fnOnClick = onClickHandlers.gpsPoints;
            getMarkersFunctionInfo = {
              fnGetMarkers: mapMarkerService.getLaptopClosestGpsMarkers
            };
            break;
          default: //laptopTravelLines.....
            fnOnClick = onClickHandlers.travelLines;
            getMarkersFunctionInfo = {
              fnGetMarkers: mapMarkerService.getLaptopTravelLineMarkers,
              args: me.arrows.bind(me)
            };
            break;
        }

        // We don't need to remove any layers from the map before adding
        // the new ones
        if (!bClearMapLayers) {
          const featureLayer = (!getMarkersFunctionInfo.args) ?
            getMarkersFunctionInfo.fnGetMarkers(sortedFeatures[layerName], me.logMarkerInfo) :
            getMarkersFunctionInfo.fnGetMarkers(sortedFeatures[layerName], getMarkersFunctionInfo.args, me.logMarkerInfo);
          if (featureLayer) {
            featureLayer.eachLayer((marker) => {
              me.mapLayerGroups[layerName].addLayer(marker);
            });
          }
        } else {  // We're removing the existing layers first
          me.myMap.removeLayer(me.mapLayerGroups[layerName]);
          me.mapLayerGroups[layerName] = (!getMarkersFunctionInfo.args) ?
            getMarkersFunctionInfo.fnGetMarkers(sortedFeatures[layerName], me.logMarkerInfo) :
            getMarkersFunctionInfo.fnGetMarkers(sortedFeatures[layerName], getMarkersFunctionInfo.args, me.logMarkerInfo);

          if (getMarkersFunctionInfo.args && arrows) {
            arrows.forEach((layer) => {
              me.mapLayerGroups[layerName].addLayer(layer);
            });
          }
        }

        // Only add the layer to the map if the filer/viewModel is selected for
        // the layer name/type
        if (me.mapViewModel[layerName]) {
          if (me.mapLayerGroups[layerName]) {
            me.myMap.addLayer(me.mapLayerGroups[layerName]);
            me.mapLayerGroups[layerName].on('click', fnOnClick.bind(me));
          }
        }
      });
    },

    /**
     * Create markers for phone track data and add it to the map
     * PHONE_TRACK_LAYER_NAMES: ['phoneGpsPoints', 'phoneClosestGpsPoint', 'phoneTravelLines'],
     * @param {*} sortedFeatures
     */
    loadAndAddPhoneTrackMarkers(sortedFeatures, onClickHandlers, arrows, bClearMapLayers = false) {
      const me = this;

      //'phoneGpsPoints', 'phoneClosestGpsPoint', 'phoneTravelLines',
      me.PHONE_TRACK_LAYER_NAMES.forEach((layerName) => {
        let fnOnClick,
          getMarkersFunctionInfo;
        switch (layerName) {
          case 'phoneGpsPoints':
            fnOnClick = onClickHandlers.gpsPoints;
            getMarkersFunctionInfo = {
              fnGetMarkers: mapMarkerService.getPhoneGpsMarkers
            };
            break;
          case 'phoneClosestGpsPoint':
            fnOnClick = onClickHandlers.gpsPoints;
            getMarkersFunctionInfo = {
              fnGetMarkers: mapMarkerService.getPhoneClosestGpsMarkers
            };
            break;
          default: //phoneTravelLines.....
            fnOnClick = onClickHandlers.travelLines;
            getMarkersFunctionInfo = {
              fnGetMarkers: mapMarkerService.getPhoneTravelLineMarkers,
              args: me.phoneArrows.bind(me)
            };
            break;
        }

        // We don't need to remove any layers from the map before adding
        // the new ones
        if (!bClearMapLayers) {
          const featureLayer = (!getMarkersFunctionInfo.args) ?
            getMarkersFunctionInfo.fnGetMarkers(sortedFeatures[layerName], me.logMarkerInfo) :
            getMarkersFunctionInfo.fnGetMarkers(sortedFeatures[layerName], getMarkersFunctionInfo.args, me.logMarkerInfo);

          if (featureLayer) {
            featureLayer.eachLayer((marker) => {
              me.mapLayerGroups[layerName].addLayer(marker);
            });
          }
        } else {  // We're removing the existing layers first
          me.myMap.removeLayer(me.mapLayerGroups[layerName]);
          me.mapLayerGroups[layerName] = (!getMarkersFunctionInfo.args) ?
            getMarkersFunctionInfo.fnGetMarkers(sortedFeatures[layerName], me.logMarkerInfo) :
            getMarkersFunctionInfo.fnGetMarkers(sortedFeatures[layerName], getMarkersFunctionInfo.args, me.logMarkerInfo);

          if (getMarkersFunctionInfo.args && arrows) {
            arrows.forEach((layer) => {
              me.mapLayerGroups[layerName].addLayer(layer);
            });
          }
        }

        // Only add the layer to the map if the filer/viewModel is selected for
        // the layer name/type
        if (me.mapViewModel[layerName]) {
          if (me.mapLayerGroups[layerName]) {
            me.myMap.addLayer(me.mapLayerGroups[layerName]);
            me.mapLayerGroups[layerName].on('click', fnOnClick.bind(me));
          }
        }
      });
    },

    /**
     * Fit map to the bounds of all the points, or if none, use default continental US bounds..
     * @param {*} features
     */
    fitAllBoundsOnMap(features) {
      let bounds;
      // Make sure the length is greater than 0 (no items) or just 1 (closest GPS/cluster/stop point)
      if (features && features.length > 1) {
        bounds = L.geoJson(features).getBounds();
      } else {
        //Set default bounds to continental USA if no points
        bounds = (this.allPoints && this.allPoints.length > 0) ? this.allPoints.getBounds() : MAP_CONSTANTS.DEFAULT_BOUNDS;
      }

      // Set bounds

      // Make sure we have valid bounds (not null and length > 0)
      if (bounds) {
        this.myMap.fitBounds(bounds, {
          // animate: false,
          // padding: [25, 25]
          animate: true
        });
      }
    },

    /**
     * Get all valid features in the mapTasksData object
     * @param {*} mapTasksData
     * @param {*} bRemoveInactiveAddress
     */
    getAllPoints(mapTasksData, bRemoveInactiveAddress) {
      if (!mapTasksData || mapTasksData.length === 0) {
        return;
      }

      let taskData = [];

      // If specified remove inactive staff address
      if (bRemoveInactiveAddress) {
        mapTasksData.forEach((feature) => {
          if (feature.properties.tag !== 'address_inactive') {
            taskData.push(feature);
          }
        })
      }
      // Get all points that will be placed on the map
      return L.geoJson(taskData);
    },

    /**
     * Display a popup for a track related item: GPS, Cluster, Closest GPS
     * @param {*} latLng
     * @param {*} popupContent
     */
    showTrackPopup(latLng, popupContent) {
      this.mapTrackPopup.setLatLng(latLng);
      this.mapTrackPopup.setContent(popupContent);
      this.myMap.openPopup(this.mapTrackPopup);
    },

    // #region Filter/clear map marker methods

    /**
     * Show\hide the filter (map marker settings) popup
     * @param evt
     */
    showFilterPopup: function (evt) {
      this.toggleFilter = !this.toggleFilter;
    },

    /**
     * Helper method used to clear all markers from the map.
     * CLEARABLE_LAYER_NAMES = [
     *   MAP_CONSTANTS.VALIDATION_MARKER_TYPES.TASKS, MAP_CONSTANTS.VALIDATION_MARKER_TYPES.VALID_TASKS,
     *   MAP_CONSTANTS.VALIDATION_MARKER_TYPES.EROC_TASKS, MAP_CONSTANTS.VALIDATION_MARKER_TYPES.MROC_TASKS,
     *   MAP_CONSTANTS.VALIDATION_MARKER_TYPES.SUSPECT_TASKS, MAP_CONSTANTS.VALIDATION_MARKER_TYPES.STAFF_HOME,
     *   MAP_CONSTANTS.VALIDATION_MARKER_TYPES.CLUSTERS, MAP_CONSTANTS.VALIDATION_MARKER_TYPES.STOP_POINTS,
     *   MAP_CONSTANTS.VALIDATION_MARKER_TYPES.LAPTOP_GPS_POINTS, MAP_CONSTANTS.VALIDATION_MARKER_TYPES.PHONE_GPS_POINTS,
     *   MAP_CONSTANTS.VALIDATION_MARKER_TYPES.LAPTOP_CLOSEST_GPS_POINTS, MAP_CONSTANTS.VALIDATION_MARKER_TYPES.PHONE_CLOSEST_GPS_POINTS,
     *   MAP_CONSTANTS.VALIDATION_MARKER_TYPES.LAPTOP_TRAVEL_LINES, MAP_CONSTANTS.VALIDATION_MARKER_TYPES.PHONE_TRAVEL_LINES]
     */
    clearAll: function () {

      const CLEARABLE_LAYER_NAMES = [
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.TASKS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.VALID_TASKS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.EROC_TASKS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.MROC_TASKS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.SUSPECT_TASKS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.STAFF_HOME,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.CLUSTERS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.STOP_POINTS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.LAPTOP_GPS_POINTS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.PHONE_GPS_POINTS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.LAPTOP_CLOSEST_GPS_POINTS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.PHONE_CLOSEST_GPS_POINTS,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.LAPTOP_TRAVEL_LINES,
        MAP_CONSTANTS.VALIDATION_MARKER_TYPES.PHONE_TRAVEL_LINES
      ];

      let me = this;  //reference to this scoped for foreach
      CLEARABLE_LAYER_NAMES.forEach((layerName) => {
        me.mapViewModel[layerName] = false;
        me.onMapSettingsChanged(me.mapViewModel[layerName], layerName);
      });
    },

    /**
     * Handles changes to mapLayerGroups model. This is used to display or
     * hide markers on the map. This is used in the filter\map markers
     * selection popup when a user selects markers for display\hide.
     *
     */
    onMapSettingsChanged: function (bShowLayers, layerName) {
      if (this.mapLayerGroups[layerName]) {
        if (bShowLayers) {
          this.myMap.addLayer(this.mapLayerGroups[layerName]);
        } else {
          this.myMap.removeLayer(this.mapLayerGroups[layerName]);
        }
      }

    },

    // #endregion

    // #region find address methods

    /**
     * Show\hide the find address popup
     *
     * @param evt
     */
    showAddressPopup: function (evt) {
      this.toggleAddress = !this.toggleAddress;
    },

    /**
     * Creates an instance of the address model based on the values entered into the form on find address popup and makes a call to the
     * GEO Service to find the lat and lng so that the address can be displayed on the map.
     */
    createAddress: function () {
      let postaddr = '';
      //validate address
      if ((this.addressModel.city && this.addressModel.state !== 'SS') || (this.addressModel.zipcode)) {

        this.errLocate = {
          hasError: false,
          errMessage: ''
        };

        if (this.addressModel.streetNum !== '' && this.addressModel.streetNum !== null)
          postaddr = this.addressModel.streetNum;

        if (this.addressModel.streetPref !== 'Select' && this.addressModel.streetPref !== null)
          postaddr = postaddr + "+" + this.addressModel.streetPref;

        if (this.addressModel.streetName !== '' && this.addressModel.streetName !== null)
          postaddr = postaddr + "+" + this.addressModel.streetName;

        if (this.addressModel.streetType !== 'Select' && this.addressModel.streetType !== null)
          postaddr = postaddr + "+" + this.addressModel.streetType;

        if (this.addressModel.streetSuf !== 'Select' && this.addressModel.streetSuf !== null)
          postaddr = postaddr + "+" + this.addressModel.streetSuf;

        if (this.addressModel.unitType !== 'Select' && this.addressModel.unitType !== null)
          postaddr = postaddr + "+" + this.addressModel.unitType;

        if (this.addressModel.city !== '' && this.addressModel.city !== null)
          postaddr = postaddr + "+" + this.addressModel.city;

        if (this.addressModel.state !== 'SS' && this.addressModel.state !== null)
          postaddr = postaddr + "+" + this.addressModel.state;

        if (this.addressModel.zipcode !== '' && this.addressModel.zipcode !== null)
          postaddr = postaddr + "+" + this.addressModel.zipcode;

        // in Google format address= 1500+Research Blvd+Rockville+MD+20850
        this.address2Locate = postaddr;

        // call geo coding service to get info
        const me = this;
        geoService.geocode(postaddr)
          .then((resp) => {
            me.toggleAddress = false;
            me.foundAddress(resp);
          })
          .catch((err) => {
            const msg = (err.response && err.response.data) ? err.response.data :
              'Problem locating address'
            this.errLocate = {
              hasError: true,
              errMessage: msg
            };
          });
      } else {
        this.errLocate = {
          hasError: true,
          errMessage: 'Please input City and State, Or ZipCode.'
        };
      }
    },

    /**
     * Clears the address model used in the find address popup.
     */
    clearAddress: function () {
      // clean address model
      this.addressModel = {
        streetNum: '',
        streetPref: '',
        streetName: '',
        streetType: '',
        streetSuf: '',
        unitType: '',
        streetUnitNo: '',
        city: '',
        state: '',
        zipcode: ''
      };

      this.errLocate = {
        hasError: false,
        errMessage: ''
      };
    },

    /**
     * Clears the address model, clears the error message, and closes the poup.
     */
    closeAddress: function () {
      this.clearAddress()
      this.toggleAddress = false
    },

    /**
     * Builds the found address information popup window and adds it to the map.
     * once it is added to the map the popup is displayed.
     */
    foundAddress: function (data) {
      if (data) {
        let address = data.data[0];
        if (address) {
          let out = [];
          // create popup text
          out.push("<div>");
          out.push("<table class='popup-table'>");
          out.push('<tbody>');
          out.push('<tr class="odd">');
          out.push('<td> Address</td>');
          out.push('<td>' + address.formattedAddress + '</td>');
          out.push('</tr>');
          out.push('<tr class="even">');
          out.push('<td> Geo Precision <span show-help tmpl="geoPrecision.help.html" glyp="glyphicon glyphicon-info-sign" glypstyle="cursor:pointer; color: #02849E;" > <span></td>');
          out.push('<td>' + address.geometry.locationType + '</td>');
          out.push('</tr>');
          out.push('<tr class="odd">');
          out.push('<td> Latitude</td>');
          out.push('<td>' + address.geometry.location.lat + '</td>');
          out.push('</tr>');
          out.push('<tr class="even">');
          out.push('<td> Longitude</td>');
          out.push('<td>' + address.geometry.location.lng + '</td>');
          out.push('</tr>');
          out.push('</tbody>');
          out.push("</table>");
          out.push("</div>");
          const outString = out.join('');

          // create address marker, add to map and display
          const marker = L.marker([address.geometry.location.lat, address.geometry.location.lng], {
            icon: L.icon(MAP_CONSTANTS.MARKER_ICONS.foundAddressMarker)
          })
            .addTo(this.myMap)
            .bindPopup(outString)
            .openPopup();

          this.foundAddressMarkers.push(marker);

          this.toggleAddress = false;
          this.clearAddress();
        } else {
          this.errLocate = {
            hasError: true,
            errMessage: 'Address not found'
          };
        }

      } else {
        this.errLocate = {
          hasError: true,
          errMessage: 'No data found'
        };
      }
    },

    /**
     * Handles events emitted from the leaflet map, like popup actions such
     * as clicking show closest GPS or Cluster from the task popup.
     * @param {*} evt
     */
    onMapEvent(evt) {
      const details = evt.detail;
      if (details.type === MAP_CONSTANTS.MAP_EVENT_TYPES.GET_TASK_TRACK) {
        const taskId = details.taskId;
        let criteria = {
          study: this.study,
          taskUUID: taskId,
          staffId: this.staffId
        };

        this.$store.commit(this.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING, true);

        this.$store.dispatch(this.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE.GET_TRACKS_FOR_TASK, criteria).then((results) => {
          let r = results;
        })
          .catch((err) => {
            console.error(err);
          });
      } else if (details.type === MAP_CONSTANTS.MAP_EVENT_TYPES.CLOSEST_CLUSTER) {
        this.showClosestClusterClicked = true;
        this.onShowClosestCluster(details.clusterId);
      } else if (details.type === MAP_CONSTANTS.MAP_EVENT_TYPES.CLOSEST_POINT) {
        this.onShowClosestGPS(details.pointId);
      }
    },

    // #endregion
  },
  directives: {
    "map-event": {
      beforeMount: function (el, binding) {
        // Define ourClickEventHandler
        const ourClickEventHandler = event => {
          if (el.contains(event.target) && el !== event.target) {
            // as we are attaching an click event listern to the document (below)
            // ensure the events target is outside the element or a child of it
            binding.value(event); // before binding it
          }
        };
        // attached the handler to the element so we can remove it later easily
        el.__vueClickEventHandler__ = ourClickEventHandler;

        // attaching ourClickEventHandler to a listener on the document here
        document.addEventListener("eagle_map_event", ourClickEventHandler);
      },
      unmounted: function (el) {
        // Remove Event Listener
        document.removeEventListener("eagle_map_event", el.__vueClickEventHandler__);
      }
    }
  },
};
</script>

<style>
.mymap {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-left: 1px solid #17677d;
  border-right: 1px solid #17677d;
  border-bottom: 1px solid #17677d;
}

#underMapArea {
  margin-left: 10px;
  height: 100%;
}

.mymap.full-screen {
  position: static;
  border: 5px solid #17677d;
  border-radius: 5px;
  z-index: 20000;
}

.center {
  text-align: center;
}

.test-img-style {
  height: 500px;
  width: 5px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.mdb-list-item {
  float: left;
  color: white;
  margin: 0px 5px 0px 0px;
  height: 50px;
}

#myFilter {
  color: rgba(21, 102, 124, 0.9);
}

#topRightCorner {
  color: white;
}

v-list-item {
  color: white;
}

.map-button {
  width: 32px;
  height: 32px;
  line-height: 30px;
  background-color: #fff9;
  color: #17677d;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  border: 1px solid;
  margin-left: 11px;
  border-radius: 3px;
  font-size: 18px;
  border-radius: 50px;
}

.map-button.drawing {
  background-color: #104756;
  color: #fafafa;
}

.map-link {
  line-height: 30px;
  background-color: #fff9;
  color: #17677d;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  border: 1px solid;
  margin-left: 11px;
  border-radius: 3px;
  font-size: 18px;
}

.legend .legend-inner.leaflet-control-layers-expanded label span {
  display: block;
  width: 50px;
  height: 50px;
  float: left;
  background-image: url(../assets/wgmm_icon_set_sprite.svg);
  background-repeat: no-repeat;
  background-size: 878px 1766px;
  margin-top: -10px;
}

.legend .legend-inner.leaflet-control-layers-expanded label.interviewer-home span {
  background-position: -660px -1314px;
}

.legend .legend-inner.leaflet-control-layers-expanded label.cluster span {
  background-position: -268px -1318px;
}

.legend .legend-inner.leaflet-control-layers-expanded label.laptop-gps span {
  background-position: -352px -1305px;
}

.legend .legend-inner.leaflet-control-layers-expanded label.phone-gps span {
  background-position: -454px -1305px;
}

.laptop {
  background-image: url(../assets/wgmm_ico_map_laptop.svg);
  background-position: 50% 50%;
}

.laptop.disabled {
  background-image: url(../assets/wgmm_ico_map_laptop_disabled.svg);
}

.cellphone {
  background-image: url(../assets/wgmm_ico_map_phone.svg);
  background-position: 50% 50%;
}

.cellphone.disabled {
  background-image: url(../assets/wgmm_ico_map_phone_disabled.svg);
}

.v-input__control>.v-input__slot {
  border: none !important;
}

.v-input--selection-controls.v-input .v-label {
  margin-bottom: 0;
  font-weight: bold !important;
}

td {
  text-align: left;
  vertical-align: top;
}

.address-table tr:nth-child(even) {
  background: #f3f3f3;
}

.address-table td {
  padding-bottom: 5px;
  font-size: 20px;
  vertical-align: middle;
}

.leaflet-touch .leaflet-bar a {
  border-color: #17677d;
}

.leaflet-touch .leaflet-control-layers,
.leaflet-touch .leaflet-bar {
  border: 1px solid #17677d !important;
}

.v-application a {
  color: #17677d !important;
}

.maploader {
  z-index: 1000000000;
  color: blue;
  background-color: #2c758978;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
}

.maploadernoshow {
  z-index: 1000000000;
  color: blue;
  background-color: #2c758978;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  display: none;
}

.bottom-right {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

.clock {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: #e0e0e0;
  margin: 10px auto;
  border: 5px solid #2c7589;
  position: relative;
  box-shadow: 0 5px 0 0 rgba(0, 0, 0, 0.3), inset 0 5px 0 0 rgba(0, 0, 0, 0.3), inset 0 0 0 34px #e0e0e0;
}

.clock:after {
  content: '';
  width: 2px;
  height: 40px;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  box-shadow: inset 0 2px 0 0 #fff, inset 0 20px 0 0 #2c7589;
  animation: clock 0.5s linear infinite;
}

.clock:before {
  content: '';
  width: 2px;
  height: 30px;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  box-shadow: inset 0 2px 0 0 #fff, inset 0 15px 0 0 #2c7589;
  animation: clockb 6s linear infinite;
}

@keyframes clock {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes clockb {
  100% {
    transform: rotate(360deg);
  }
}

.locate-error {
  color: red;
  font-weight: bold;
}

.checkLabel {
  color: rgba(21, 102, 124, 0.9);
  font-weight: bold !important
}

/* Hide Leaflet markers and their shadows when filtered out */
.hide-marker {
    display: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
}

	.gps-playback-pulse-icon {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.pulse-center {
		width: 10px;
		height: 10px;
		background-color: #0078ff;
		border: 2px solid white;
		border-radius: 50%;
		box-shadow: 0 0 4px rgba(0,0,0,0.5);
		z-index: 2;
	}
	.pulse-ring {
		position: absolute;
		width: 32px;
		height: 32px;
		border: 3px solid #0078ff;
		border-radius: 50%;
		background-color: rgba(0, 120, 255, 0.2);
		animation: gpsPulse 1s ease-out infinite;
		z-index: 1;
	}
	@keyframes gpsPulse {
		0% { transform: scale(0.2); opacity: 1; }
		100% { transform: scale(1.4); opacity: 0; }
	}

  .pacman-cursor {
    width: 24px;
    height: 24px;
    position: relative;
}

/* Common style for top and bottom jaw */
.pacman-top, .pacman-bottom {
    position: absolute;
    width: 0;
    height: 0;
    border: 12px solid #f1c40f; /* Retro Arcade Yellow */
    border-radius: 50%;
    border-right-color: transparent; /* Creates the mouth cavity */
}

/* Animation triggers */
.pacman-top {
    animation: chomp-top 0.3s ease-in-out infinite alternate;
}

.pacman-bottom {
    animation: chomp-bottom 0.3s ease-in-out infinite alternate;
}

/* Keyframes to crunch the jaws together */
@keyframes chomp-top {
    0% { transform: rotate(270deg); }
    100% { transform: rotate(360deg); }
}

@keyframes chomp-bottom {
    0% { transform: rotate(90deg); }
    100% { transform: rotate(0deg); }
}
</style>
